<template>
	<el-dialog
		:visible.sync="dialogShow"
		width="80%"
		top="5vh"
	>
		<div slot="title" class="dialog-title1">
			<div class="title1">{{ '商品详情 - ID: ' + sondata.id }}</div>
		</div>
		<!--订单详情 - ID: -->
		<div class="titleInfo el-row">
			<div class="el-col el-col-4">
				<label for>店铺：</label>
				<span v-if="sondata.seller && sondata.seller.shop_name != ''">
					{{ sondata.seller && sondata.seller.shop_name }}
				</span>
			</div>
			<div class="el-col el-col-5">
				<label for>订单状态：</label>
				{{ sondata.orderStatus }}
			</div>
			<div class="el-col el-col-5">
				<label for>购买日期：</label>
				{{ sondata.purchaseDate }}
			</div>
			<div class="el-col el-col-5">
				<label for>ID：</label>
				{{ sondata.amazonOrderId }}
			</div>
			<div class="el-col el-col-5" v-show="sondata.orderNumber">
				<label for>订单编码：</label>
				{{ sondata.orderNumber }}
			</div>
		</div>
		<div class="speed-of-progress">
			<el-steps :active="2" align-center>
				<el-step title="已付款" description="已付款"></el-step>
				<el-step title="已采购" description="已采购"></el-step>
				<el-step title="虚发货" description="虚发货"></el-step>
				<el-step title="已签收" description="已签收"></el-step>
				<el-step title="国际已发货" description="国际已发货"></el-step>
				<el-step title="已完成" description="已完成"></el-step>
			</el-steps>
		</div>
		<br />
		<el-button type="primary" @click="savePurchaseSkuData">保存sku和采购链接映射关系</el-button>
		<el-button type="primary" @click="setAllPurchaseUrl">采购链接同首个sku</el-button>
		<div class="goods-box clear">
			<div
				class="el-row"
				v-for="(item, index) in sondata.orderItems"
				:key="index"
				style="margin-top:20px;"
			>
				<!-- <div class="el-col el-col-19"> -->
				<div class="el-col el-col-3" style="width:12.5%;">
					<el-image
						style="border-radius: 5px;width: 66%;"
						:src="item.imageUrl"
						:preview-src-list="[item.imageUrl]"
					>
					</el-image>
					<!-- <img style="" :src="item.imageUrl" alt /> -->
				</div>
				<div class="el-col el-col-21">
					<el-row>
						<el-col :span="18" class="title-row">
							<a
								target="_blank"
								:href="item.saleLink"
								class="line-height el-col el-col-11"
							>
								{{ item.title }}
							</a>
							<el-button type="text" icon="el-icon-copy-document" @click="myCopyText(item.title)"></el-button>
							<!-- <router-link to="{path:'www.amazon.fr/gp/product/{{item.title}}}">{{item.title}}</router-link> -->
						</el-col>
						<!-- <el-col :span="2" :offset="1">
                            <el-button class="dright" type="primary" plain @click="hxMarket">海逊商场</el-button>
                        </el-col> -->
						<el-col :span="4">
							<el-button
								class="dright"
								type="primary"
								style="margin-left:15px;"
								@click="HXShops"
								>海逊商城</el-button
							>
							<el-popover
								placement="left-start"
								trigger="hover"
								@show="showsourcing(item.sellerSKU)"
								@hide="hidesourcing">
								<p class="textlang">{{sourcingurl}}</p>
								<el-button slot="reference" class="dright" @click="Viewsourcing(item.sellerSKU)">查看货源</el-button>
							</el-popover>
							<!-- <el-button
								class="dright"
								@click="Viewsourcing(item.sellerSKU)"
								>查看货源</el-button
							> -->
						</el-col>
					</el-row>
					<p class="line-height">
						<label for>SKU:</label>
						<span>{{ item.sellerSKU }}</span>
						<label class="label-l" for>数量:</label>
						<span>{{ item.quantityOrdered }}</span>
						<br v-if="item.property" />
						<label for v-if="item.property">属性:</label>
						<span v-if="item.property">{{ item.property }}</span>
						<br v-if="item.customizeInfo" />
						<label for v-if="item.customizeInfo">商品定制信息:</label>
						<span v-if="item.customizeInfo">{{ item.customizeInfo }}</span>
						<el-button
							type="primary"
							style="margin-left:15px;"
							@click="Replace(item)"
							>添加订单核对图片</el-button
						>
					</p>
					<el-row>
						<p v-if="item.giftWrapLevel">
							<label>礼品包装类型：</label>
							<span>{{ item.giftWrapLevel }}</span>
						</p>
					</el-row>
					<div class="purchase-input-box">
						<div class="purchase-title">
							<div class="text">采购信息：</div>
							<div class="btn">
								<el-button @click="addPurchase(item.sellerSKU)" type="primary">添加</el-button>
							</div>
						</div>
						<div class="purchase-content">
							<div class="purchase-row" v-for="(item1, index1) in (purchaseSkuData[item.sellerSKU] || [])" :key="index1">
								<div class="item">
									<el-input
										placeholder="采购链接"
										v-model="item1.purchaseDetailUrl" style="width: 400px;" class="purchase-url-input">
										<div slot="suffix">
											<el-button  type="text"  @click="useExistLink(item1, item.sellerSKU)">引用已有链接</el-button>
											<el-button type="text"  @click="parseLink(item1)">解析</el-button>
											<el-button type="text"  @click="gotoDetail(item1.purchaseDetailUrl)">跳转</el-button>
										</div>
									</el-input>
								</div>
								<div class="item">
									<el-select v-model="item1.purchaseDetailSku" placeholder="采购链接中的sku" style="width: 200px" clearable creatable filterable @change="createAutoPurchaseText" allow-create :ref="item1.ref">
										<el-option
											v-for="option in (item1.purchaseDetailUrl ? skuOptionsMap[item1.purchaseDetailUrl] ? skuOptionsMap[item1.purchaseDetailUrl] : [] : [])"
											:key="option"
											:label="option"
											:value="option"
										></el-option>
									</el-select>
								</div>
								<div class="item">
									<el-input v-model="item1.purchaseNum" @input="createAutoPurchaseText" placeholder="采购数量" style="width: 120px" type="number" />
								</div>
								<div class="item">
									<el-input v-model="item1.remark" placeholder="备注" @input="createAutoPurchaseText" style="width: 200px" />
								</div>
								<div class="item">
									<el-select v-model="item1.status" placeholder="是否自动采购" style="width: 120px" clearable>
										<el-option label="自动采购" value="1"></el-option>
										<el-option label="取消自动采购" value="0"></el-option>
									</el-select>
								</div>
								<el-button icon="el-icon-close" style="color: #f56c6c" type="text" @click="delPurchase(item.sellerSKU, index1)"></el-button>
							</div>
						</div>
					</div>
					<!-- <div class="el-row" style="padding: 0 0 5px 0;"> -->
					<!-- 点击编辑 -->
					<!-- <div class="el-col el-col-18" v-show="menuhide">
                            <div class="el-col el-col-4 el-input-left">
                                <el-input v-model="input1">
                                    <template slot="prepend">采购价:</template>
                                </el-input>
                            </div>
                            <div class="el-col el-col-4 el-input-left">
                                <el-input v-model="input1">
                                    <template slot="prepend">返佣:</template>
                                </el-input>
                            </div>
                            <div class="el-col el-col-4 el-input-left">
                                <el-input v-model="input1">
                                    <template slot="prepend">其他费用:</template>
                                </el-input>
                            </div>
                            <div class="el-col el-col-6 el-input-left">
                                <el-input v-model="input1">
                                    <template slot="prepend">运单号码:</template>
                                </el-input>
                            </div>
                            <div class="el-col el-col-5 el-input-left">
                                <el-input v-model="input1">
                                    <template slot="prepend">物流公司:</template>
                                </el-input>
                            </div>
                        </div>
                        <div class="el-col el-col-6 line-height" v-show="menudisplay"></div>
                        <div class="el-col el-col-6 line-height" v-show="menuhide">
                            <el-button
                                class="dright"
                                style="margin-right: 30px;"
                                @click="tmenudisplay=true,menudisplay=true,menuhide=false"
                            >取消</el-button>
                            <el-button
                                class="dright"
                                style="margin-right: 10px;"
                                type="primary"
                                @click="Addedit"
                            >保存</el-button>
                        </div>
                        <div class="el-col el-col-6 line-height" v-show="delt">
                            <el-button
                                class="dright"
                                style="margin-right: 30px;"
                                @click="menudisplay=true,delt=false"
                            >取消</el-button>
                            <el-button
                                class="dright"
                                style="margin-right: 10px;"
                                type="primary"
                                @click="Adddel"
                            >确认</el-button>
                        </div>
                    </div>
                    <div class="el-row" v-show="producttype">
                        <div class="el-col el-col-18">
                            <div class="el-col el-col-4 el-input-left">
                                <el-input v-model="input1">
                                    <template slot="prepend">采购价:</template>
                                </el-input>
                            </div>
                            <div class="el-col el-col-4 el-input-left">
                                <el-input v-model="input1">
                                    <template slot="prepend">返佣:</template>
                                </el-input>
                            </div>
                            <div class="el-col el-col-4 el-input-left">
                                <el-input v-model="input1">
                                    <template slot="prepend">其他费用:</template>
                                </el-input>
                            </div>
                            <div class="el-col el-col-6 el-input-left">
                                <el-input v-model="input1">
                                    <template slot="prepend">运单号码:</template>
                                </el-input>
                            </div>
                            <div class="el-col el-col-5 el-input-left">
                                <el-input v-model="input1">
                                    <template slot="prepend">物流公司:</template>
                                </el-input>
                            </div>
                        </div>

                        <div class="el-col el-col-6 line-height">
                            <el-button
                                class="dright"
                                style="margin-right: 30px;"
                                @click="producttype=false"
                            >取消</el-button>
                            <el-button
                                class="dright"
                                style="margin-right: 10px;"
                                type="primary"
                                @click="producttype=false"
                            >保存</el-button>
                        </div>
                    </div>-->
				</div>
			</div>
			<div class="demand">
				<div class="demand_inp" style="margin-bottom:10px;">
					<label style="line-height:31px;">自动生成的采购需求预览：</label>
					<div style="line-height:31px;margin-left:10px">
						{{ autoDemandText }}
					</div>
				</div>
				<div class="demand_inp">
					<label style="line-height:31px;">采购需求：</label>
					<div style="width:70%;margin-left:10px">
						<el-input v-model="demand"></el-input>
					</div>
					<el-button
						type="primary"
						style="margin-left:10px"
						@click="insertPurchase"
						v-if="system !== 1"
						:loading="btnloading"
					>
						<span v-if="this.type == '一次采购'">确认采购</span>
						<span v-if="this.type == '二次采购'">二次采购</span>
					</el-button>
					<el-button
						type="primary"
						style="margin-left:10px"
						@click="intercept"
						:disabled="interceptdisabled"
						>拦截发货</el-button
					>
				</div>
				<el-row type="flex" style="margin-top: 10px;">
					<label style="line-height:31px;">采购需求填写标准：</label>
					<div style="margin-left:10px">
						<el-select
							value=""
							filterable
							@change="(e) => (demand = e)"
						>
							<el-option
								v-for="item in listRemarkStandard"
								:key="item.id"
								:label="item.typeName"
								:value="item.content"
							></el-option>
						</el-select>
					</div>
				</el-row>
				<div
					v-for="(value, index) in infoData.purchaseDemands"
					:key="index"
					style="width:100%"
				>
					<div
						class="demand_num"
						style="margin-top:10px; margin-bottom: 10px;"
						v-for="(value1, index) in value.purchaseItems"
						:key="index"
					>
						<div>
							<label for style="width:30%">
								采购类型：
								<span>{{ value.type }}</span>
							</label>
							<label for style="width:30%">
								采购单据号：
								<span>{{ value1.purchaseNumber }}</span>
							</label>
							<label for style="width:30%">
								采购总计：
								<span v-if="value1.purchaseTotalAmount != ''">
									[CNY]{{ value1.purchaseTotalAmount }}
								</span>
							</label>
							<label for style="width:40%">
								国内运单号：
								<span>{{ value1.internalConveyNumber }}</span>
							</label>

							<label for style="width:40%">
								采购标记：
								<el-tag
									style="margin-right:5px;"
									v-for="tag in filteredPurchaseMarkItems(value1.purchaseMarkItems)"
									:color="tag.itemName"
									:key="tag.id"
									effect="dark"
									size="mini"
									:type="tag.type"
								>
									{{ tag.itemTypeName }}
								</el-tag>
							</label>

							<label
								for
								style="width:40%"
								v-if="
									value1.remarks !== null &&
										value1.remarks.length !== 0
								"
							>
								采购备忘录：
								<el-popover
									placement="top-start"
									width="600"
									trigger="hover"
								>
									<el-table :data="value1.remarks">
										<el-table-column
											label="操作人"
											align="center"
											width="120"
										>
											<template slot-scope="scope">
												<span
													>{{ scope.row.roleName }}-{{
														scope.row.userName
													}}</span
												>
											</template>
										</el-table-column>
										<el-table-column
											label="图片"
											align="center"
											width="70"
										>
											<template slot-scope="scope">
												<el-image
													style="width: 50px; height: 50px"
													:src="
														scope.row.repayImage.url
													"
													:preview-src-list="
														scope.row.repayImage
															.repayCredentialsList
													"
												>
												</el-image>
											</template>
										</el-table-column>
										<el-table-column
											property="remarkContent"
											label="内容"
											align="center"
										></el-table-column>
										<el-table-column
											property="createTime"
											label="时间"
											align="center"
											width="100"
										></el-table-column>
									</el-table>
									<i
										class="el-icon-s-claim"
										style="font-size:20px;"
										slot="reference"
									></i>
								</el-popover>
							</label>
							<label v-if="value1.invalidStatus === 0">
								<img :src="pics" alt="" class="picsImg">
							</label>
							
						</div>
					</div>
				</div>
				<label
					class="demand_num"
					v-if="
						sondata.purchaseDemands &&
							sondata.purchaseDemands.length == 0
					"
				></label>

				<div
					v-for="(value, index) in infoData.inventorys"
					:key="index"
					style="width:100%"
				>
					<div>
						<label for style="width:30%">
							库存匹配：
						</label>
						<label for style="width:30%">
							库存批次号：
							<span>{{ value.inventoryBatchNo }}</span>
						</label>
						<label for style="width:30%">
							价格：
							<span>[CNY]{{ Number(value.purchasePrice) * Number(value.useCount) }}</span>
						</label>
					</div>
				</div>

				<div
					v-for="(value, index) in infoData.shops"
					:key="index"
					style="width:100%"
				>
					<div>
						<label for style="width:30%">
							商城匹配：
						</label>
						<label for style="width:30%">
							库存编号：
							<span>{{ value.inventoryNumber }}</span>
						</label>
						<label for style="width:30%">
							价格：
							<span>[CNY]{{ value.currentPrice }}</span>
						</label>
					</div>
				</div>
			</div>
		</div>
		<div class="address">
			<!--            <el-tabs v-model="activeName" type="card">-->
			<!--                <el-tab-pane label="收货人信息" name="first" id="address">-->
			<el-row type="flex" justify="space-between">
				<div class="order-t" style="width: 50%;">
					<div v-show="goodsdisplay">
						<el-row type="flex">
							<div>
								<label for>国家:</label>
								<span v-if="sondata.address != null">{{
									this.countryCode
								}}</span>
							</div>
							<div style="margin: 0 20px;">
								<label for>州/省:</label>
								<span v-if="sondata.address != null">{{
									this.stateOrRegion
								}}</span>
							</div>
							<div>
								<label for>城市:</label>
								<span v-if="sondata.address != null">{{
									this.city
								}}</span>
							</div>
							<div style="margin: 0 20px;">
								<label for>县</label>:
								<span v-if="sondata.address != null">{{
									this.county
								}}</span>
							</div>
						</el-row>
						<el-row type="flex">
							<div>
								<label for>收件人:</label>
								<span v-if="sondata.address != null">{{
									this.name
								}}</span>
							</div>
							<div style="margin: 0 20px;">
								<label for>ZIP:</label>
								<span v-if="sondata.address != null">{{
									this.postalCode
								}}</span>
							</div>
						</el-row>
						<el-row type="flex">
							<div>
								<label for>电话:</label>
								<span v-if="sondata.address != null">{{
									this.phone
								}}</span>
							</div>
						</el-row>
						<el-row type="flex">
							<div>
								<label for>地址1:</label>
								<span v-if="sondata.address != null">{{
									this.addressLine1
								}}</span>
							</div>
						</el-row>
						<el-row type="flex">
							<div>
								<label for>地址2:</label>
								<span v-if="sondata.address != null">{{
									this.addressLine2
								}}</span>
							</div>
						</el-row>
						<el-row type="flex">
							<div>
								<label for>地址3:</label>
								<span v-if="sondata.address != null">{{
									this.addressLine3
								}}</span>
							</div>
						</el-row>
					</div>
					<div v-show="goodshide" style="padding: 10px;">
						<div style="margin-bottom: 10px;display:flex">
							<el-input
								placeholder="请输入内容"
								v-model="countryCode"
								style="width: 220px;"
								id="countryCode"
							>
								<template slot="prepend">
									国家
								</template>
							</el-input>

							<el-input
								placeholder="请输入内容"
								v-model="stateOrRegion"
								style="width: 220px;"
								class="el-input-left"
							>
								<template slot="prepend">
									州/省
								</template>
							</el-input>

							<el-input
								placeholder="请输入内容"
								v-model="city"
								style="width: 220px;"
								class="el-input-left"
							>
								<template slot="prepend">
									城市
								</template>
							</el-input>
							<el-input
								placeholder="请输入内容"
								v-model="county"
								style="width: 220px;"
								class="el-input-left"
							>
								<template slot="prepend">
									县
								</template>
							</el-input>
						</div>

						<div style="margin-bottom: 10px;">
							<el-input
								placeholder="请输入内容"
								v-model="name"
								style="width: 220px;"
							>
								<template slot="prepend">
									收件人
								</template>
							</el-input>

							<el-input
								placeholder="请输入内容"
								v-model="postalCode"
								style="width: 220px;"
								class="el-input-left"
							>
								<template slot="prepend">
									邮编
								</template>
							</el-input>

							<el-input
								placeholder="请输入内容"
								v-model="phone"
								style="width: 220px;"
								class="el-input-left"
							>
								<template slot="prepend">
									电话
								</template>
							</el-input>
						</div>

						<div style="margin-bottom: 10px;">
							<el-input
								placeholder="请输入内容"
								v-model="addressLine1"
								style="width: 670px;"
							>
								<template slot="prepend">
									地址1
								</template>
							</el-input>
						</div>

						<div style="margin-bottom: 10px;">
							<el-input
								placeholder="请输入内容"
								v-model="addressLine2"
								style="width: 670px;"
							>
								<template slot="prepend">
									地址2
								</template>
							</el-input>
						</div>
						<div>
							<el-input
								placeholder="请输入内容"
								v-model="addressLine3"
								style="width: 670px;"
							>
								<template slot="prepend">
									地址3
								</template>
							</el-input>
						</div>
					</div>
					<div>
						<!-- <el-button
							v-show="goodsdisplay"
							type="primary"
							@click="addEdit"
							>编辑</el-button
						> -->
						<el-button
							v-show="goodshide"
							type="primary"
							@click="addSetedit"
							>保存</el-button
						>
						<el-button v-show="goodshide" @click="addSetcancel"
							>取消</el-button
						>
					</div>
				</div>
				<!--                </el-tab-pane>-->
				<!--                <el-tab-pane label="买家信息" name="second" id="address" style="margin-top:10px;">-->
				<div style="width: 50%;">
					<!-- <el-row>
            <el-col :span="2">
              <label class="label-l order-t" for>买家ID:</label>
            </el-col>
            <el-col :span="20">123</el-col>
                    </el-row>-->
					<el-row style="height: 36px;">
						<label
							style="font-size:20px;"
							class="label-l order-t"
							for
							>买家国家:</label
						>

						<span
							style="font-size:20px;"
							class="buyer"
							:style="{ color: isBlackDoc ? 'red' : '' }"
						>
							{{ sondata.countryMark }}
						</span>
					</el-row>
					<el-row style="height: 36px;">
						<label
							style="font-size:20px;"
							class="label-l order-t"
							for
							>买家名称:</label
						>

						<span
							:span="10"
							style="font-size:20px;"
							class="buyer"
							:style="{ color: isBlackDoc ? 'red' : '' }"
						>
							{{ sondata.buyerName }}
						</span>
					</el-row>
					<el-row style="height: 36px;">
						<label
							style="font-size:20px;"
							class="label-l order-t"
							for
							>买家邮箱:</label
						>
						<span
							:span="10"
							style="font-size:20px;"
							class="buyer"
							:style="{ color: isBlackDoc ? 'red' : '' }"
						>
							{{ sondata.buyerEmail }}
						</span>
					</el-row>
					<el-row style="height: 36px;" v-if="sellerType == 2">
						<label
							style="font-size:20px;"
							class="label-l order-t"
							for
							>物流公司:</label
						>
						<span
							:span="10"
							style="font-size:20px;"
							class="buyer"
							:style="{ color: isBlackDoc ? 'red' : '' }"
						>
							{{ sondata.buyerEmail }}
						</span>
					</el-row>

					<div class="el-col el-col-12" style="float:right">
						<el-button
							type="danger"
							@click="addBlack"
							v-if="system !== 1"
							>添加黑名单</el-button
						>
						<el-button
							type="success"
							@click="checkBlack"
							v-bind:disabled="disabled"
							>检测黑名单</el-button
						>
						<el-button
							type="primary"
							@click="cancleBlack"
							v-if="system !== 1"
							>移除黑名单</el-button
						>
					</div>
				</div>
				<!-- <el-button @click="lack" style="height:40px" type="primary">
					订单地址缺失解决办法
				</el-button> -->
			</el-row>
			<!--                </el-tab-pane>-->
			<!--            </el-tabs>-->
		</div>
		<div class="order-amount order-t">
			<div
				class="el-row"
				id="price"
				v-if="sondata.source == 8"
			>
				<label v-if="Number(sondata.accrualsForSale)">
					销售金额:
					<span
						>[RUB]{{
							sondata.accrualsForSale
						}}</span
					>
				</label>

				<label v-if="Number(sondata.saleCommission)">
					{{Number(sondata.saleCommission) > 0 ? '+' : '-' }} 销售代理佣金:
					<span
						>[RUB]{{
							Math.abs(sondata.saleCommission).toFixed(2)
						}}</span
					>
				</label>

				<label v-if="Number(sondata.servicesAmount)">
					{{Number(sondata.servicesAmount)  > 0 ? '+' : '-' }} Ozon代理佣金:
					<span
						>[RUB]{{
							Math.abs(sondata.servicesAmount).toFixed(2)
						}}</span
					>
				</label>

				<label v-if="Number(sondata.processingAndDelivery)">
					{{Number(sondata.processingAndDelivery) > 0 ? '+' : '-' }} 国际配送服务:
					<span
						>[RUB]{{
							Math.abs(sondata.processingAndDelivery).toFixed(2)
						}}</span
					>
				</label>

				<label v-if="Number(sondata.refundsAndCancellations)">
					{{Number(sondata.refundsAndCancellations) > 0 ? '+' : '-' }} 退款和取消:
					<span
						>[RUB]{{
							Math.abs(sondata.refundsAndCancellations).toFixed(2)
						}}</span
					>
				</label>

				<label v-if="Number(sondata.compensationAmount)">
					{{Number(sondata.compensationAmount) > 0 ? '+' : '-' }} 补偿金额:
					<span
						>[RUB]{{
							Math.abs(sondata.compensationAmount).toFixed(2)
						}}</span
					>
				</label>

				<label v-if="Number(sondata.moneyTransfer)">
					{{Number(sondata.moneyTransfer)  > 0 ? '+' : '-' }} 交货和退货费用:
					<span
						>[RUB]{{
							Math.abs(sondata.moneyTransfer).toFixed(2)
						}}</span
					>
				</label>

				<label v-if="Number(sondata.othersAmount)">
					{{Number(sondata.othersAmount) > 0 ? '+' : '-' }} 其他应计费用:
					<span
						>[RUB]{{
							Math.abs(sondata.othersAmount).toFixed(2)
						}}</span
					>
				</label>

				<label v-if="sondata.beforePrice != ''">
					= 到账:
					<span
						>[RUB]{{
							sondata.beforePrice
						}}</span
					>
				</label>
				<label v-if="Number(sondata.afterRatePrice)">
					=
					<span>[CNY]{{ sondata.afterRatePrice }}</span>
				</label>
				<label v-if="Number(sondata.costPrice)">
					- 采购价:
					<span>[CNY]{{ sondata.costPrice }}</span>
				</label>
				<label v-if="Number(sondata.channelShipping)">
					- 运费:
					<span>[CNY]{{ sondata.channelShipping }}</span>
				</label>
				<label v-if="Number(sondata.shipping)">
					- 国际运费:
					<span>[CNY]{{ sondata.shipping }}</span>
				</label>
				<label v-if="Number(sondata.platformFee)">
					- 平台管理费:
					<span>[CNY]{{ sondata.platformFee }}</span>
				</label>
				<label v-if="Number(sondata.inventoryFee)">
					- 库存成本:
					<span>[CNY]{{ sondata.inventoryFee }}</span>
				</label>
				<label v-if="Number(sondata.totalAfterSalesFee)">
					+ 平台售后:
					<span>[CNY]{{ sondata.totalAfterSalesFee }}</span>
				</label>

				<label v-if="Number(sondata.profitPrice)">
					= 利润:
					<span>[CNY]{{ sondata.profitPrice }}</span>
				</label>
			</div>
			<div
				class="el-row"
				id="price"
				v-else-if="
					Object.keys(sondata).length &&
						sondata.money &&
						Object.keys(sondata.money).length
				"
			>
				<label v-if="Object.keys(sondata.money).length">
					订单金额:
					<span
						>[{{ sondata.money.currencyCode }}]{{
							sondata.cusAmount
						}}</span
					>
				</label>

				<label v-if="Number(sondata.tax)">
					- 税:
					<span
						>[{{ sondata.money.currencyCode }}]{{
							sondata.tax
						}}</span
					>
				</label>

				<label v-if="Number(sondata.feeNum)">
					{{Number(sondata.feeNum) > 0 ? '+' : '-'}} 佣金:
					<span
						>[{{ sondata.money.currencyCode }}]{{
							Math.abs(sondata.feeNum).toFixed(2)
						}}</span
					>
				</label>

				<label v-if="Number(sondata.refund)">
					- 退款:
					<span
						>[{{ sondata.money.currencyCode }}]{{
							sondata.source === 14 ? sondata.refundChina : sondata.refund
						}}</span
					>
				</label>

				<label v-if="Number(sondata.csbafee)">
					- 亚马逊服务费:
					<span
						>[{{ sondata.money.currencyCode }}]{{
							sondata.csbafee
						}}</span
					>
				</label>

				<label v-if="Number(sondata.refundCommission)">
					- 退款管理费:
					<span
						>[{{ sondata.money.currencyCode }}]{{
							sondata.refundCommission
						}}</span
					>
				</label>
				<label v-if="sondata.beforePrice != ''">
					= 到账:
					<span
						>[{{ sondata.money.currencyCode }}]{{
							sondata.beforePrice
						}}</span
					>
				</label>
				<label v-if="Number(sondata.afterRatePrice)">
					=
					<span>[CNY]{{ sondata.afterRatePrice }}</span>
				</label>
				<label v-if="Number(sondata.costPrice)">
					- 采购价:
					<span>[CNY]{{ sondata.costPrice }}</span>
				</label>
				<label v-if="Number(sondata.channelShipping)">
					- 运费:
					<span>[CNY]{{ sondata.channelShipping }}</span>
				</label>
				<label v-if="Number(sondata.shipping)">
					- 国际运费:
					<span>[CNY]{{ sondata.shipping }}</span>
				</label>
				<label v-if="Number(sondata.platformFee)">
					- 平台管理费:
					<span>[CNY]{{ sondata.platformFee }}</span>
				</label>
				<label v-if="Number(sondata.inventoryFee)">
					- 库存成本:
					<span>[CNY]{{ sondata.inventoryFee }}</span>
				</label>
				<label v-if="Number(sondata.totalAfterSalesFee)">
					+ 平台售后:
					<span>[CNY]{{ sondata.totalAfterSalesFee }}</span>
				</label>

				<label v-if="Number(sondata.processingAndDelivery)">
					{{Number(sondata.processingAndDelivery) > 0 ? '+' : '-'}} 国际配送服务:
					<span>[CNY]{{ Math.abs(sondata.processingAndDelivery).toFixed(2) }}</span>
				</label>
				<label v-if="Number(sondata.servicesAmount)">
					{{Number(sondata.servicesAmount) > 0 ? '+' : '-'}} Ozon代理佣金:
					<span>[CNY]{{ Math.abs(sondata.servicesAmount).toFixed(2) }}</span>
				</label>


				<!-- <template v-if="sondata.financialData &&  sondata.financialData.length > 0">
					<label v-for="(item, index) in sondata.financialData" :key="index">
						{{item.amount > 0 ? '+' : '-'}} {{ item.title ? item.title : item.accrual_type }} :
						<span>[CNY]{{ Math.abs(item.amountToCNY) }}</span>
					</label>
				</template> -->
				<label v-if="Number(sondata.profitPrice)">
					= 利润:
					<span>[CNY]{{ sondata.profitPrice }}</span>
				</label>
			</div>
			<div>
				佣金：包含佣金,运费等费用,若为正值说明需扣除,若为负值则为盈利
			</div>
			<div v-if="financialEvents != null">
				<span>当前商品净值：{{ financialEvents.netRevenue }}[{{ sondata.money.currencyCode }}]</span>
				<div style="background-color: rgba(168,168,168,0.3);border-radius: 15px;">
					<div v-for="item in financialEvents.transactionLines">
					<span>交易类型：{{ item.transactionType }}</span> <span>交易金额：{{ item.netPayable }}[{{ sondata.money.currencyCode }}]</span>
				</div>
				</div>
			</div>
		</div>
		<div class="waybill order-t">
			<div class="waybill-title">
				<!-- <p
					style="border-bottom:1px solid #dcdfe6;margin-bottom:10px;padding-bottom:10px"
				>
					税号：<el-input
						:class="bor"
						style="width:150px"
						:disabled="vatNumberEdit"
						v-model="sondata.vatNumber"
					></el-input>
					<el-button
						style="margin-left:10px"
						v-if="vatNumberEdit"
						type="primary"
						@click="vatNumberEdit = false"
					>
						编辑
					</el-button>
					<el-button
						@click="vatNum"
						style="margin-left:10px"
						v-else
						type="success"
					>
						保存
					</el-button>
					<span style="color:red;margin-left:15px"
						>发件人税号格式为12位字母+数字组合</span
					>
				</p> -->
				<el-row
					style="margin-bottom: 10px;"
					type="flex"
					justify="space-between"
					align="center"
				>
					<div>
						<label>国际运单</label>
						<el-button
							type="primary"
							v-if="sondata.applyFromStatus === 2"
							@click="openIncreaseWaybill"
							>添加</el-button
						>
						<el-tooltip
							effect="dark"
							content="如需开启自用渠道，请联系海逊总公司。"
							placement="top"
							v-else
						>
							<el-button type="info">添加</el-button>
						</el-tooltip>
					</div>
					<el-tooltip
						effect="dark"
						content="启用之后，将作废该订单所有的未出库国际运单，之后的国际物流问题全部由海逊物流统一管理服务。"
						placement="top-end"
						v-if="sondata.applyFromStatus === 2"
					>
						<el-button type="primary" @click="startHYLogistics"
							>启用海逊物流</el-button
						>
					</el-tooltip>
					<el-button type="info" v-else>启用海逊物流</el-button>
				</el-row>
				<el-card
					shadow="hover"
					v-for="item in infoChannel"
					:key="item.id"
				>
					<el-row type="flex">
						<div class="channel-flex">
							<h4>渠道：</h4>
							<span v-if="item.type == 1">三态</span>
							<span v-if="item.type == 2">云途</span>
							<span v-if="item.type == 3">燕文</span>
							<span v-if="item.type == 4">第三方</span>
							<span v-if="item.type == 5">k5</span>
							<span v-if="item.type == 6">递四方</span>
							<span v-if="item.type == 7">云途（服装）</span>
							<span v-if="item.type == 8">泰嘉</span>
							<span v-if="item.type == 9">八达通</span>
							<span v-if="item.type == 10">云途A</span>
							<span v-if="item.type == 11">递四方A</span>
							<span v-if="item.type == 12">捷岸</span>
							<span v-if="item.type == 13">立德</span>
							<span v-if="item.type == 14">艾姆勒</span>
							<span v-if="item.type == 15">shopee物流</span>
							<span v-if="item.type == 16">ozon物流</span>
							<span v-if="item.type == 17">柏电</span>
              				<span v-if="item.type == 18">柏电自有</span>
							<span v-if="item.type == 19">万立德</span>
							<span v-if="item.type == 20">浩亿达</span>
							<span v-if="item.type == 21">Cheer</span>
							<span v-if="item.type == 22">辰达通</span>
              				<span v-if="item.type == 23">辰达通A</span>
							<span v-if="item.type == 24">浩亿达_厦门</span>
							<span v-if="item.type == 25">艾派</span>
							<span v-if="item.type == 26">艾派_厦门</span>
							<span v-if="item.type == 27">dealfy</span>
							<span v-if="item.type == 28">菜鸟</span>
							<span v-if="item.type == 29">艾派COD</span>
							<span v-if="item.type == 30">欧邮通</span>
							<span v-if="item.type == 32">速卖通物流</span>
							<span v-if="item.type == 33">Walmart_SWW</span>
							<span v-if="item.type == 34">商壹国际</span>
						</div>
						<div class="channel-flex">
							<h4>订单渠道id：</h4>
							{{ item.orderChannelId }}
						</div>
						<div class="channel-flex">
							<h4>运单号：</h4>
							{{ item.conveyNumber }}
						</div>
						<div class="channel-flex">
							<h4>追踪号：</h4>
							{{ item.trackNumber }}
						</div>
						<div class="channel-flex">
							<h4>转单号：</h4>
							{{ item.transferOrderNumber }}
						</div>
					</el-row>
					<el-row type="flex" justify="space-between">
						<el-row type="flex">
							<div class="channel-flex">
								<h4>国家：</h4>
								{{ item.countryName }}
							</div>
							<div class="channel-flex">
								<h4>路线：</h4>
								{{ item.channelWay }}
							</div>
							<div class="channel-flex">
								<h4>时间：</h4>
								{{ item.createTime }}
							</div>
						</el-row>
						<div class="right-btn-container">
							<el-button
								class="padding0"
								type="text"
								@click="toVoid(item)"
								v-if="item.status !== 1"
								>作废</el-button
							>
							<span v-else style="color:red;margin-right:10px;"
								>已作废</span
							>
							<el-button
								class="padding0"
								type="text"
								@click="openPrintPage(item)"
								>打印({{ item.printfCount || 0 }})</el-button
							>
							<!-- <el-button class="padding0" type="text" @click="Detailed">明细</el-button> -->
						</div>
					</el-row>
				</el-card>
				<!-- <el-button type="primary" @click="addWaybill">添加</el-button> -->
			</div>
			<div class="PrintInvoice">
				<el-button type="primary" style="margin-right: 20px" @click="dialogSetFormVisible=true" :disabled="estimateBool" v-if="UserInfo.system == 1 || UserInfo.system == 2 || UserInfo.superDepartmentName=='财务部'">设置预估费用</el-button>
				<el-button type="success" @click="Print_Invoice"
					>打印国际运单({{ infoData.printCount }})</el-button
				>
			</div>
		</div>
		<div>
			<el-tabs
				type="border-card"
				v-model="activeName1"
				@tab-click="handleClick"
			>
				<el-tab-pane label="操作日志" name="1">
					<el-timeline>
						<el-timeline-item
							v-for="(activity, index) in activities"
							:key="index"
							:timestamp="activity.createTime"
						>
							{{ activity.operateName }}
						</el-timeline-item>
					</el-timeline>
				</el-tab-pane>
				<el-tab-pane label="订单备忘录" name="2">
					<div style="width:100%;display: flex;">
						<el-button type="primary" @click="Themomo = true"
							>添加备忘录</el-button
						>
					</div>

					<div
						class="borbuttom"
						v-for="(item, index) in this.momoList"
						:key="index"
					>
						<div
							style="display: flex;justify-content: left;margin-top:15px;"
						>
							<p style="width:150px;">{{ item.roleUserName }}:</p>
							<div style="margin-top: 11px;">
								<el-image
									class="voucher"
									style="width: 30px; height: 30px"
									:src="item.repayImage.url"
									:preview-src-list="
										item.repayImage.repayCredentialsList
									"
								>
									<div slot="error" class="image-slot">
										<img
											src="../../../assets/imags/暂无图片.png"
											alt=""
											style="width:30px;height:25px;"
										/>
									</div>
								</el-image>
							</div>
							<p style="width:100%;margin-left:30px;">
								{{ item.remarkContent }}
							</p>
						</div>
						<div
							style="margin-top:10px;height:30px;"
							v-if="item.purchaseMarkItems !== null"
						>
							<span>国内:</span>
							<el-tag
								style="margin-left:10px;border:0;"
								v-for="tag in item.purchaseMarkItems"
								:color="tag.itemName"
								:key="tag.id"
								effect="dark"
								size="mini"
								:type="tag.type"
							>
								{{ tag.itemTypeName }}
							</el-tag>
						</div>
						<div
							style="margin-top:10px;height:30px;"
							v-if="item.channelMarkItems !== null"
						>
							<span>国际:</span>
							<el-tag
								style="margin-left:10px;border:0;"
								v-for="tag in item.channelMarkItems"
								:color="tag.itemName"
								:key="tag.id"
								effect="dark"
								size="mini"
								:type="tag.type"
							>
								{{ tag.itemTypeName }}
							</el-tag>
						</div>
						<div style="height:22px;">
							<span
								style="float:right;color:#409eff;cursor: pointer;"
								v-if="item.remarkStatus == 1"
								@click="OpenToDealWith(item)"
								>待处理</span
							>
							<span
								style="float:right;"
								v-if="item.remarkStatus == 2"
								>已处理</span
							>
							<span
								style="float:right;"
								v-if="item.remarkStatus == 3"
								>已完结</span
							>
							<span style="float:right;margin-right:20px;">{{
								item.createTime
							}}</span>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="国际物流备注" name="3">
					<div style="width:100%;display: flex;">
						<el-button type="primary" @click="AddChannel"
							>添加物流备注</el-button
						>
					</div>

					<div
						class="borbuttom"
						v-for="(item, index) in this.momoList"
						:key="index"
					>
						<div
							style="display: flex;justify-content: left;margin-top:15px;"
						>
							<p style="width:150px;">{{ item.roleUserName }}:</p>
							<div style="margin-top: 11px;">
								<el-image
									class="voucher"
									style="width: 30px; height: 30px"
									:src="item.repayImage.url"
									:preview-src-list="
										item.repayImage.repayCredentialsList
									"
								>
									<div slot="error" class="image-slot">
										<img
											src="../../../assets/imags/暂无图片.png"
											alt=""
											style="width:30px;height:25px;"
										/>
									</div>
								</el-image>
							</div>

							<p style="width:100%;margin-left:30px;">
								{{ item.remarkContent }}
							</p>
						</div>
						<div
							style="margin-top:10px;height:30px;"
							v-if="item.channelMarkItems !== null"
						>
							<span>国际:</span>
							<el-tag
								style="margin-left:10px;border:0;"
								v-for="tag in item.channelMarkItems"
								:color="tag.itemName"
								:key="tag.id"
								effect="dark"
								size="mini"
								:type="tag.type"
							>
								{{ tag.itemTypeName }}
							</el-tag>
						</div>
						<div style="height:22px;">
							<span
								style="float:right;color:#409eff;cursor: pointer;"
								v-if="item.remarkStatus == 1"
								@click="OpenToDealWith(item)"
								>待处理</span
							>
							<span
								style="float:right;"
								v-if="item.remarkStatus == 2"
								>已处理</span
							>
							<span
								style="float:right;"
								v-if="item.remarkStatus == 3"
								>已完结</span
							>
							<span style="float:right;margin-right:20px;">{{
								item.createTime
							}}</span>
						</div>
					</div>
				</el-tab-pane>
				<el-dialog
					width="40%"
					title="添加备忘录"
					:visible.sync="Themomo"
					append-to-body
				>
					<div class="headTag">
						<div v-if="this.remarkType === 1">
							<el-dropdown
								trigger="click"
								@command="GNTagsChange"
							>
								<el-button type="primary">
									国内运单标记<i
										class="el-icon-arrow-down el-icon--right"
									></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<div
										v-for="(item, index) in this.colorList2"
										:key="index"
									>
										<el-dropdown-item :command="item">{{
											item.itemTypeName
										}}</el-dropdown-item>
									</div>
								</el-dropdown-menu>
							</el-dropdown>

							<el-tag
								v-for="(tag, index) in GNtags"
								style="margin-left:5px;border:0;"
								@close="GNhandleClose(tag, index)"
								:color="tag.itemName"
								:key="tag.id"
								closable
								effect="dark"
								size="small"
								:type="tag.type"
							>
								{{ tag.itemTypeName }}
							</el-tag>
						</div>

						<div style="margin-top:15px;">
							<div v-if="this.remarkType == 1">
								<el-dropdown
									trigger="click"
									@command="GGTagsChange"
								>
									<el-button type="primary">
										国际运单标记<i
											class="el-icon-arrow-down el-icon--right"
										></i>
									</el-button>
									<el-dropdown-menu slot="dropdown">
										<div
											v-for="(item, index) in this
												.colorList3"
											:key="index"
										>
											<el-dropdown-item
												:command="item"
												v-if="
													item.itemTypeId == 1 ||
														item.itemTypeId == 2 ||
														item.itemTypeId == 3 ||
														item.itemTypeId == 4 ||
														item.itemTypeId == 5 ||
														item.itemTypeId == 6 ||
														item.itemTypeId == 7 ||
														item.itemTypeId == 8 ||
														item.itemTypeId == 9 ||
														item.itemTypeId == 10 ||
														item.itemTypeId == 11 ||
														item.itemTypeId == 12
												"
												>{{
													item.itemTypeName
												}}</el-dropdown-item
											>
										</div>
									</el-dropdown-menu>
								</el-dropdown>
								<el-tag
									v-for="(tag, index) in GGtags"
									style="margin-left:5px;border:0;"
									@close="GGhandleClose(tag, index)"
									:color="tag.itemName"
									:key="tag.id"
									closable
									effect="dark"
									size="small"
									:type="tag.type"
								>
									{{ tag.itemTypeName }}
								</el-tag>
							</div>

							<div v-if="this.remarkType == 3">
								<el-dropdown
									trigger="click"
									@command="GGTagsChange"
								>
									<el-button type="primary">
										运单更新状态<i
											class="el-icon-arrow-down el-icon--right"
										></i>
									</el-button>
									<el-dropdown-menu slot="dropdown">
										<div
											v-for="(item, index) in this
												.colorList3"
											:key="index"
										>
											<el-dropdown-item
												:command="item"
												v-if="item.itemTypeId >= 13"
												>{{
													item.itemTypeName
												}}</el-dropdown-item
											>
										</div>
									</el-dropdown-menu>
								</el-dropdown>
								<el-tag
									v-for="(tag, index) in GGtags"
									style="margin-left:5px;border:0;"
									@close="GGhandleClose(tag, index)"
									:color="tag.itemName"
									:key="tag.id"
									closable
									effect="dark"
									size="small"
									:type="tag.type"
								>
									{{ tag.itemTypeName }}
								</el-tag>
							</div>
						</div>
					</div>

					<div style="margin-top:15px;">
						<el-upload
							ref="upload"
							:action="action"
							list-type="picture-card"
							:on-success="handleAvatarSuccess"
							:on-preview="handlePictureCardPreview"
							:on-remove="handleRemove"
							:headers="customHeaders"
						>
							<i class="el-icon-plus" style="color: #0724ef;"></i>
						</el-upload>
						<el-dialog
							:visible.sync="dialogVisible1"
							append-to-body
						>
							<img width="100%" :src="dialogImageUrl1" alt />
						</el-dialog>
					</div>
					<div style="margin-top:20px;">
						<el-input
							type="textarea"
							:autosize="{ minRows: 4, maxRows: 10 }"
							placeholder="请输入内容"
							v-model="textarea1"
						>
						</el-input>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button @click="Themomo = false">取 消</el-button>
						<el-button type="primary" @click="AddMomo"
							>添加</el-button
						>
					</div>
				</el-dialog>

				<el-dialog
					width="40%"
					title="处理"
					:visible.sync="ToDealWith"
					append-to-body
				>
					<div class="headTag">
						<div
							style="margin-top:15px;"
							v-if="
								this.remarkType === 1 &&
									this.openWithGNTags !== null
							"
						>
							<span>国内运单标记：</span>
							<el-tag
								v-for="(tag, index) in this.openWithGNTags"
								style="margin-left:5px;border:0;"
								@close="delGNTags(tag, index)"
								:color="tag.itemName"
								:key="tag.id"
								closable
								effect="dark"
								size="small"
								:type="tag.type"
							>
								{{ tag.itemTypeName }}
							</el-tag>
						</div>

						<div
							style="margin-top:15px;"
							v-if="this.openWithGGTags !== null"
						>
							<span>国际运单标记：</span>
							<el-tag
								v-for="(tag, index) in this.openWithGGTags"
								style="margin-left:5px;border:0;"
								@close="delGGTags(tag, index)"
								:color="tag.itemName"
								:key="tag.id"
								closable
								effect="dark"
								size="small"
								:type="tag.type"
							>
								{{ tag.itemTypeName }}
							</el-tag>
						</div>
					</div>

					<div style="margin-top:15px;">
						<el-upload
							ref="upload"
							:action="action"
							list-type="picture-card"
							:on-success="handleAvatarSuccess2"
							:on-preview="handlePictureCardPreview2"
							:on-remove="handleRemove2"
							:headers="customHeaders"
						>
							<i class="el-icon-plus" style="color: #0724ef;"></i>
						</el-upload>
						<el-dialog
							:visible.sync="dialogVisible2"
							append-to-body
						>
							<img width="100%" :src="dialogImageUrl2" alt />
						</el-dialog>
					</div>
					<div style="margin-top:20px;">
						<el-input
							type="textarea"
							:autosize="{ minRows: 4, maxRows: 10 }"
							placeholder="请输入内容"
							v-model="textarea2"
						>
						</el-input>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="SubEnd"
							>提交并完结</el-button
						>
						<el-button type="primary" @click="SubNoEnd"
							>提交未完结</el-button
						>
					</div>
				</el-dialog>
			</el-tabs>
		</div>
		<div class="el-dialog__foote" style="margin-top: 40px;">
			<div class="dialog-footer">
				<el-button @click="dialogShow = false">取消</el-button>
				<el-button type="primary" @click="operationDetermination"
					>确定</el-button
				>
			</div>
		</div>
		<!-- 国际运单添加 -->
		<Internationaldis ref="internationaldis"></Internationaldis>
		<!-- 国际运单明细 -->
		<Detaileddis ref="Detaileddist"></Detaileddis>
		<!-- 海逊商场 -->
		<Market ref="Markett"></Market>
		<!-- 打印国际运单 -->
		<el-dialog
			:before-close="Close_Print_File"
			width="40%"
			title="打印国际运单"
			:visible.sync="PrintInvoiceVisible"
			append-to-body
		>
			<el-form
				label-position="right"
				size="medium"
				status-icon
				label-width="130px"
				:rules="Print_rules"
				:model="Print_form"
			>
				<el-form-item label="包" prop="paks">
					<el-input
						v-model="Print_form.paks"
						autocomplete="off"
						placeholder="请输入包"
					></el-input>
				</el-form-item>
				<el-form-item label="数量" prop="qty">
					<el-input
						v-model.number="Print_form.qty"
						@input="Qty_Change"
						placeholder="请输入整数"
					></el-input>
				</el-form-item>
				<el-form-item label="单价" prop="unitPrice">
					<el-input v-model="Print_form.unitPrice"></el-input>
				</el-form-item>
				<el-form-item label="总金额" prop="totalAmount">
					<el-input v-model="Print_form.totalAmount"></el-input>
				</el-form-item>
				<el-form-item label="重量" prop="weight">
					<el-input
						v-model="Print_form.weight"
						placeholder="请填写重量"
					></el-input>
				</el-form-item>
				<el-form-item
					label="托运/出口人签名"
					prop="signatureOfShipperExporter"
				>
					<el-input
						v-model="Print_form.signatureOfShipperExporter"
						placeholder="请填写托运人/出口人签名"
					></el-input>
				</el-form-item>
				<el-form-item
					label="货物完整描述"
					prop="fullDescriptionOfGoods"
				>
					<el-input
						type="textarea"
						maxlength="70"
						show-word-limit
						v-model="Print_form.fullDescriptionOfGoods"
						placeholder="请填写货物描述"
					></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="Countermand">取 消</el-button>
				<el-button type="primary" @click="Print_Determine"
					>确 定</el-button
				>
			</div>
		</el-dialog>
		<el-dialog
			title="货源链接"
			:visible.sync="dialogFormVisible"
			append-to-body
			width="35%"
		>
			<el-form :model="form">
				<el-form-item label>
					<el-row v-for="(item, index) in blue_point" :key="index">
						<el-col :span="22" style="position: relative;">
							<el-input
								placeholder="请输入内容"
								v-model="item.value"
								style="padding: 5px 0 0 0;"
							>
								<el-button
									slot="append"
									@click="handleURL(item.value)"
									>访问链接</el-button
								>
							</el-input>
						</el-col>
						<el-col :span="2">
							<el-button
								type="danger"
								@click="edit_blue_del(item, index)"
								icon="el-icon-close"
							></el-button>
						</el-col>
					</el-row>
					<span style="color:#F56C6C" v-if="isRequestDone">
						<template v-if="blue_point.length">
							此链接记录货源链接，可填写1-10条，非必填。
						</template>
						<template v-else>
							暂无货源链接
						</template>
					</span>
				</el-form-item>
			</el-form>
			<el-button
				type="primary"
				@click="edit_blue_point"
				v-if="system !== 1"
				>增加一条记录</el-button
			>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" :plain="true" @click="handleTure"
					>确 定</el-button
				>
			</div>
		</el-dialog>
		<!-- 处理 -->
		<el-dialog
			title="处理"
			:visible.sync="dialogTableVisible"
			append-to-body
		>
			<div style="border-radius: 2px;border:1px #eee solid;">
				<el-upload
					action="https://jsonplaceholder.typicode.com/posts/"
					list-type="picture-card"
					:on-preview="handlePictureCardPreview"
					:on-remove="handleRemove"
				>
					<i class="el-icon-plus" style="color: #0724ef;"></i>
				</el-upload>
				<el-dialog :visible.sync="dialogVisible" append-to-body>
					<img width="100%" :src="dialogImageUrl" alt />
				</el-dialog>
				<el-input
					type="textarea"
					:rows="4"
					placeholder="请输入内容"
					v-model="textarea"
				></el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogTableVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogTableVisible = false"
					>确 定</el-button
				>
			</div>
		</el-dialog>
		<!-- 更换订单图片-->
		<el-dialog
			title="更换订单图片"
			:visible.sync="OrderImage"
			append-to-body
			width="500px"
			top="30vh"
		>
			<el-upload
				ref="uploadData"
				class="avatar-uploader"
				:action="action"
				:show-file-list="false"
				:on-success="handleAvatarSuccess1"
				:headers="customHeaders"
			>
				<img v-if="imageUrl" :src="imageUrl" class="avatar" />
				<i v-else class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
			<p style="color:red;margin-top:15px;">
				注意事项：请添加正方形图片，建议像素长度小于等于500*500
			</p>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelUpdata">取 消</el-button>
				<el-button type="primary" @click="AddImage">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog
			title="海逊商城"
			:visible.sync="Hymall"
			width="50%"
			append-to-body
		>
			<div>
				<el-input v-model="ShopsString" style="width:82%;"></el-input>
				<el-button
					type="primary"
					style="margin-left:10px;"
					@click="HXShopsSearch"
					>搜索</el-button
				>
				<el-button type="primary" @click="HXShopsReset">重置</el-button>
			</div>
			<div style="margin-top:15px;">
				<el-col
					:span="4"
					v-for="(o, index) in this.GoodsMall"
					:key="index"
					style="margin-left:20px;width:200px;"
				>
					<el-card :body-style="{ padding: '0px' }">
						<img
							:src="o.images"
							style="width:200px;height:200px;"
						/>
						<div
							style="display: flex;justify-content: space-between;padding: 14px;"
						>
							<div class="bottom clearfix">
								<div>{{ o.productFullName }}</div>
								<div>库存数量：{{ o.actualCount }}</div>
							</div>

							<div class="bottom clearfix">
								<div>现价：{{ o.currentPrice }}</div>
								<div>原价：{{ o.originalPrice }}</div>
							</div>
						</div>
					</el-card>
				</el-col>
			</div>
		</el-dialog>
		<el-dialog
			title="设置预估费用"
			:visible.sync="dialogSetFormVisible"
			append-to-body
			width="35%"
		>
			<el-form ref="ruleFormSet">
				<el-row :gutter="20">
					<el-col :span="12" :offset="0">
						<el-form-item label="采购预估费用">
							<el-input-number v-model="purchaseCostEstimate" size="small" :min="0">
							</el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="0">
						<el-form-item label="物流预估费用">
							<el-input-number v-model="logisticsCostEstimate" size="small" :min="0">
							</el-input-number>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogSetFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitSet" :loading="btnSetLoading"
					>确 定</el-button
				>
			</div>
		</el-dialog>
		<IncreaseWaybill
			ref="IncreaseWaybill"
			@refreshData="IncreaseWaybillRefreshData"
		/>
	</el-dialog>
</template>
<script>
import Internationaldis from './internationaldis.vue'
import Detaileddis from './Detaileddis.vue'
import Market from './Market.vue'
import FBMOrder from '../FBMOrder'
import IncreaseWaybill from './increaseWaybill'
import { printInfo, increaseNum,copyText } from '@/utils/common.js'
import { ajaxPost, Baseurl } from '../../../api/api/api'
export default {
	name: 'FBMOrderedit',
	components: {
		Internationaldis,
		Market,
		Detaileddis,
		IncreaseWaybill,
	},
	props: {
		rate: {
			type: Array,
			default() {
				return []
			},
		},
	},
	computed: {
		filteredPurchaseMarkItems() {
			return (purchaseMarkItems) => {
				if (!purchaseMarkItems || !Array.isArray(purchaseMarkItems)) {
					return [];
				}
				return purchaseMarkItems.filter((tag) => tag.itemTypeName !== '成本异常');
			};
		},
	},
	data() {
		var checkQty = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('数量不能为空'))
			}
			setTimeout(() => {
				if (!Number.isInteger(value)) {
					callback(new Error('请输入数字'))
				} else {
					if (value <= 0) {
						callback(new Error('数量必须大于0'))
					} else {
						callback()
					}
				}
			}, 1000)
		}
		var pics = require('../../../assets/imags/pics.png')
		return {
			// 财务事件
			financialEvents:null,
			sellerType: '',
			bor: '',
			pics: pics,
			autoDemandText: '',
			// vatNumberEdit: true,
			PrintInvoiceVisible: false,
			Print_form: {
				// 包
				paks: '',
				// 描述
				fullDescriptionOfGoods: '',
				// 数量
				qty: null,
				// 单价
				unitPrice: null,
				// 重量
				weight: null,
				// 出口人签名
				signatureOfShipperExporter: '',
				// 总金额
				totalAmount: null,
			},

			Print_rules: {
				paks: [
					{ required: true, message: '请填写包', trigger: 'blur' },
				],
				fullDescriptionOfGoods: [
					{
						required: true,
						message: '货物完整描述',
						trigger: 'blur',
					},
				],
				qty: [{ validator: checkQty, required: true, trigger: 'blur' }],
				weight: [
					{ required: true, message: '请填写重量', trigger: 'blur' },
				],
				signatureOfShipperExporter: [
					{
						required: true,
						message: '请输入出口人签名',
						trigger: 'blur',
					},
				],
			},
			activeName1: '1',
			activities: [],
			cData: [],
			title1: '',
			GoodsMall: [],
			ShopsString: '',
			// title2:sondata.id,
			radio: 0,
			tmenudisplay: true,
			menudisplay: true,
			dialogShow: false,
			menuhide: false,
			goodsdisplay: true,
			goodshide: false,
			delt: false,
			Hymall: false,
			options: '',
			value: '',
			select: '',
			textarea: '',
			input: '',
			input1: '',
			imageUrl: '',
			staff: [
				{
					value: '1',
					label: '全部',
				},
			],
			blue_point: [],
			dialogFormVisible: false,
			form: {},
			producttype: false,
			activeName: 'first',
			url: require('../../../assets/imags/picture.png'),
			srcList: [
				'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
				'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg',
			],
			dialogTableVisible: false,
			goodslist: [],
			surplusprofitValue: '',
			dialogImageUrl: '',
			dialogImageUrl1: '',
			dialogImageUrl2: '',
			dialogVisible: false,
			dialogVisible1: false,
			dialogVisible2: false,
			demand: '',
			countryCode: '',
			stateOrRegion: '',
			county: '',
			city: '',
			postalCode: '',
			phone: '',
			addressLine3: '',
			addressLine2: '',
			addressLine1: '',
			name: '',
			id: '',
			amazonOrderId: '',
			buyerId: '',
			disabled: '',
			amountReceived: '',
			type: '',
			purchasePrice: '',
			system: '',
			sondata: {},
			isBlackDoc: false,
			infoChannel: {},
			interceptdisabled: false,
			OrderImage: false,
			momoList: [],
			Themomo: false,
			ToDealWith: false,
			colorList1: [],
			colorList2: [],
			colorList3: [],
			infoData: '',
			dadata: [],

			action: Baseurl + 'imageController/uploadImage',
			customHeaders: { token: localStorage.getItem('token') },
			imageData: [],
			imageData1: [],
			images: [],
			images1: [],
			textarea1: '',
			textarea2: '',
			remarkType: '',
			ImageId: '',
			GGtags: [],
			GNtags: [],
			openWith: '',
			openWithGGTags: '',
			openWithGNTags: '',
			remarkStatusNo: '',
			deletePurchaseMark: [],
			deleteChannelMark: [],
			listRemarkStandard: [],
			isRequestDone: false,
			btnloading: false,
			sourcingurl: '加载中...',
			purchaseCostEstimate: 0,
			logisticsCostEstimate: 0,
			dialogSetFormVisible: false,
			btnSetLoading: false,
			estimateBool: false,
			UserInfo: {},
			sellerSKU: '',
			purchaseSkuData: {},
			skuOptionsMap: [],
		}
	},
	methods: {
		submitSet() {
			if (this.purchaseCostEstimate == undefined || this.purchaseCostEstimate == null) {
				this.$message.error("采购预估费用不能为空！")
				return
			}
			if (this.logisticsCostEstimate == undefined || this.logisticsCostEstimate == null) {
				this.$message.error("物流预估费用不能为空！")
				return
			}
			let API = Baseurl + 'orderCostEstimateController/setOrderCostEstimate'
			this.btnSetLoading = true
			ajaxPost(API, {
				orderId: this.sondata.orderId,
				amazonOrderId: this.sondata.amazonOrderId,
				purchaseCostEstimate: this.purchaseCostEstimate,
				logisticsCostEstimate: this.logisticsCostEstimate,
				purchaseEstimated: 1,
				logisticsEstimated: 1
			}).then(() => {
				this.$message.success('设置成功')
				this.dialogSetFormVisible = false
				this.btnSetLoading = false
				this.$parent.Search()
			})
		},
		myCopyText(text){
			copyText(text).then(() => {
				// 复制成功
				this.$message.success('复制成功');
			}).catch(() => {
				// 复制失败
				this.$message.error('复制失败');
			});
			

		},
		lack() {
			window.open(
				'http://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E9%83%A8%E5%88%86%E8%AE%A2%E5%8D%95%E5%9C%B0%E5%9D%80%E7%BC%BA%E5%A4%B1%E7%9A%84%E8%A7%A3%E5%86%B3%E5%8A%9E%E6%B3%95.pdf'
			)
		},
		createAutoPurchaseText(){
			const resArr = [];
			for(let i=0; i<this.sondata.orderItems.length; i++){
				const item = this.sondata.orderItems[i];
				const arr = this.purchaseSkuData[item.sellerSKU];
				if(arr && arr.length > 0){
					for(let j=0; j<arr.length; j++){
						let text = arr[j]['purchaseDetailSku'] + '*' + ((arr[j]['purchaseNum'] ? arr[j]['purchaseNum'] : 0) * item.quantityOrdered);
						if(arr[j]['remark'] && arr[j]['remark'].trim() !== ''){
							text += '（备注：' + arr[j]['remark'] + '）';
						}
						resArr.push(text);
					}
				}
			}
			this.autoDemandText = resArr.join('+');
		},
		vatNum() {
			let API = Baseurl + 'orderController/updateOrder'
			// console.log(this.sondata.amazonOrderId)
			let str = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{12}$/
			console.log(str.test(this.sondata.vatNumber))
			if (!str.test(this.sondata.vatNumber)) {
				this.bor = 'bor1'
				this.$message.error('发件人税号格式为12位字母+数字组合')
				return
			}
			this.bor = ''
			ajaxPost(API, {
				vatNumber: this.sondata.vatNumber,
				amazonOrderId: this.sondata.amazonOrderId,
			}).then((res) => {
				if (res.data.code == 200) {
					this.vatNumberEdit = true
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.data.message)
				}
				// console.log(res)
			})
		},
		async openPrintPage(item) {
      if (item.type == 12) {
        window.open('http://159.75.210.47:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 13) {
        window.open('http://129.204.214.77:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 15 || item.type == 16) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != ''){
          window.open(item.conveyNumberUrl);
        } else {
          this.$message.error('暂无面单！')
        }
      } else if (item.type == 17) {
        window.open('http://47.96.42.132:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 18) {
        let API = Baseurl + 'baidian_order/getOrderLable'
        ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
          window.open(res.data)
        })
      } else if (item.type == 19) {
        let API = Baseurl + 'wanLeaderTypeController/getWanLeaderLabal'
        ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
          let data = JSON.parse(res.data)
          window.open(data.data)
        })
      } else if (item.type == 20 || item.type == 24) {
        window.open('http://1.14.254.116:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 21) {
        window.open('http://106.52.235.113:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 22) {
        let API = Baseurl + 'jiTuTypeController/getPrintUrl'
        ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
          let data = JSON.parse(res.data)
          window.open(data.data)
        })
      } else if (item.type == 23) {
        let API = Baseurl + 'udaTypeController/getUdaLabal'
        ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
          let data = JSON.parse(res.data)
          window.open(data.data)
        })
      } else if (item.type == 25 || item.type == 26) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != ''){
          window.open(item.conveyNumberUrl);
        } else {
          window.open('http://159.75.205.97:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
        }
      } else if (item.type == 27) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != ''){
          window.open(item.conveyNumberUrl);
        } else {
          let API = Baseurl + 'dealfyController/getWaybill'
          ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
            let data = JSON.parse(res.data)
            window.open(data.data)
          })
        }
      } else if (item.type == 28) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
          window.open(item.conveyNumberUrl);
        } else {
          let API = Baseurl + 'cainiaoOrderController/getWaybill'
          ajaxPost(API, { conveyNumber: item.conveyNumber, type: 28 }, { responseType: 'blob' }).then((res) => {
            let data = JSON.parse(res.data)
            window.open(data.data)
          })
        }
      } else if (item.type == 29) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
          window.open(item.conveyNumberUrl);
        }
      } else if (item.type == 30) {
        window.open('http://43.139.202.31:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
      } else if (item.type == 31) {
        if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
          window.open(item.conveyNumberUrl);
        } else {
          let API = Baseurl + 'cainiaoOrderController/getWaybill'
          ajaxPost(API, { conveyNumber: item.conveyNumber, type: 31 }, { responseType: 'blob' }).then((res) => {
            let data = JSON.parse(res.data)
            window.open(data.data)
          })
        }
      } else if (item.type == 32) {
        if (item.channelWayEn == 'AE_GLOBAL_JIT') {
             let API = Baseurl + 'aliexpressSemiHostingCollection/getShippingMarkPdf'
          ajaxPost(API, { sellerId: this.infoData.sellerId, purchaseOrderNo: item.fulfillmentId }, { responseType: 'blob' }).then((res) => {
            let data = JSON.parse(res.data)
            window.open(data.data)
          })
        } else {
          let API = Baseurl + 'aliexpressLogistics/getPrintinfo'
          ajaxPost(API, { international_logistics_id: item.conveyNumber, sellerId: this.infoData.sellerId }, { responseType: 'blob' }).then((res) => {
            let data = JSON.parse(res.data)
            window.open(data.data)
          })
        }
      } else if (item.type == 33) {
        let API = Baseurl + 'walmartShipping/downloadLabel'
        // console.log(this.infoData);
        ajaxPost(API, { sellerId: this.infoData.sellerId, trackingNo: item.conveyNumber, carrierShortName: item.channelName }, { responseType: 'blob' }).then((res) => {
          let data = JSON.parse(res.data)
          window.open(data.data)
        })
      } else if (item.type == 34) {
        let API = Baseurl + 'shangYiTypeController/getOrderLabel'
        ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
          let data = JSON.parse(res.data)
          window.open(data.data)
        })
      } else {
        await printInfo(item)
      }
			// if(item.type != 12) {
			// 	await printInfo(item)
			// }else{
			// 	window.open('http://159.75.210.47:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
			// }
			await increaseNum(item)
			item.printfCount += 1
		},
		gotoDetail(url){
			window.open(url);
		},
		// 使用已存在的链接
		useExistLink(item, sku){
			ajaxPost(Baseurl + 'productController/getProductSourceLink', {
				sku: sku,
				countryMark: this.sondata.countryMarks.countryMark,
			}).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					const d = data.filter(item => item);
					if(d.length == 1){
						this.$set(item, 'purchaseDetailUrl', d[0]);
					}else{
						this.$message.info('该SKU存在多个货源链接，请手动填写！')
						return
					}
				}else{
					this.$message.error(res.data.message);
				}
			})
		},
		randomString(length = 16) {
			const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			let result = '';
			for (let i = 0; i < length; i++) {
				result += chars.charAt(Math.floor(Math.random() * chars.length));
			}
			return result;
		},
		// 添加采购信息
		addPurchase(sku){
			if(this.purchaseSkuData[sku]){
				const arr = this.purchaseSkuData[sku];
				arr.push({
					"purchaseDetailUrl": "",
					"purchaseDetailSku": "",
					"purchaseNum": "",
					"remark": "",
					"status": "1",
					ref: this.randomString(16)
				});
				this.$set(this.purchaseSkuData, sku, arr);
			}else{
				this.$set(this.purchaseSkuData, sku, [
					{
						"purchaseDetailUrl": "",
						"purchaseDetailSku": "",
						"purchaseNum": "",
						"remark": "",
						"status": "1",
						ref: this.randomString(16)
					}
				]);
			}
		},
		// 调用领星解析url
		parseLink(item){
			const url = item.purchaseDetailUrl;
			ajaxPost(
				"https://hx1.hyxun.top/api/parseLink",
				{ url: url }
			).then((res) => {
				if(res.status == 200){
					if(res.data.data.code == 1){
						const result = res.data.data.data[0];
						const arr = result['sku_infos'] || [];
						const options = [];
						for(let i = 0; i < arr.length; i++){
							const item = arr[i];
							if(item['amount_on_sale'] && item['amount_on_sale'] > 0){
								let text = [];
								for(let j = 0; j < item['attributes'].length; j++){
									const attr = item['attributes'][j];
									text.push(attr['attribute_value']);
								}
								options.push(text.join(' '));
							}
						}
						this.$set(this.skuOptionsMap, url, options);
						this.$refs[item.ref] && this.$refs[item.ref][0].toggleMenu();
						// this.$set(item, 'skuOptions', options)
					}else {
						if(res.data.data.code == -999){
							this.$message.error('令牌过期,请登录领星账号,然后使用插件获取令牌使用')
						}else{
							this.$message.error(res.data.data.msg)
						}
					}
				}else{
					this.$message.error('解析失败：' + res.data.message)
				}
			})
		},
		delPurchase(sku, index){
			const arr = this.purchaseSkuData[sku];
			arr.splice(index, 1);
			this.$set(this.purchaseSkuData, sku, arr);
		},
		savePurchaseSkuData(){
			const result = {};
			for(let k in this.purchaseSkuData){
				const skuArr = this.purchaseSkuData[k];
				const arr = [];
				for(let i = 0; i < skuArr.length; i++){
					const item = skuArr[i];
					if(item.purchaseDetailUrl || item.purchaseDetailSku || item.purchaseNum){
						if((item.purchaseNum + '').trim() && isNaN(Number(item.purchaseNum))){
							this.$message.error('采购数量请输入数字');
							return;
						}
						arr.push({
							sku: k,
							purchaseDetailUrl: item.purchaseDetailUrl || null,
							purchaseDetailSku: item.purchaseDetailSku || null,
							purchaseNum: item.purchaseNum || null,
							remark: item.remark || null,
							shopId: this.sondata.seller.id,
							status: item.status
						});
					}
				}
				result[k+ '~~~@#$%&*--' + this.sondata.seller.id] = arr; //~~~@#$%&*-- 分割sku和店铺id
			}
			ajaxPost(
				Baseurl + 'purchaseSkuController/replaceBySkuAndShop',
				result
			).then((res) => {
				if(res.data.code == 200){
					this.$message.success('保存成功');
				}
			})
		},
		// 采购链接同首行
		setAllPurchaseUrl(){
			let index = 0;
			let url = '';
			for(let k in this.purchaseSkuData){
				if(index == 0){
					const firstSkuArr = this.purchaseSkuData[k];
					if(firstSkuArr.length > 0){
						url = firstSkuArr[0].purchaseDetailUrl;
					}
				}else{
					const skuArr = this.purchaseSkuData[k];
					if(skuArr.length > 0){
						for(let i = 0; i < skuArr.length; i++){
							skuArr[i].purchaseDetailUrl = url;
						}
						this.$set(this.purchaseSkuData, k, skuArr);
					}
				}
				index++;
			}
		},
		getPurchaseSkuData(){
			const arr = [];
			const obj2 = {};
			for(let i = 0; i < this.sondata.orderItems.length; i++){
				arr.push(this.sondata.orderItems[i].sellerSKU);
				obj2[this.sondata.orderItems[i].sellerSKU] = [];
			}
			const params = {
				sku: arr,
				shopId: this.sondata.seller.id,
			}
			ajaxPost(
				Baseurl + 'purchaseSkuController/getByShopAndSkus',
				params
			).then((res) => {
				const obj = {};
				if(res.data.code == 200){
					const result = res.data.data;
					for(let i = 0; i < result.length; i++){
						const item = result[i];
						if(!obj[item.sku]){
							obj[item.sku] = [];
						}
						item['ref'] = this.randomString(16);
						obj[item.sku].push(item);
					}
				}
				
				for(let k in obj2){
					if(obj[k] && obj[k].length > 0){
						obj2[k] = obj[k];
					}else{
						obj2[k] = [
							{
								"purchaseDetailUrl": "",
								"purchaseDetailSku": "",
								"purchaseNum": "",
								"remark": "",
								"status": "1",
								ref: this.randomString(16)
							}
						];
					}
				}
				let purchaseDemand = this.sondata.purchaseDemand || '';
				if(purchaseDemand.includes("(自动)")){
					purchaseDemand = purchaseDemand.replace("(自动)", "");
					const regex = /([\u4e00-\u9fff\w]+)\*\d+/g;
					const matches = [...purchaseDemand.matchAll(regex)].map(m => m[1]);
					const orderItems = this.sondata.orderItems;
					orderItems.sort((a,b)=>{
						return matches.indexOf(obj[a.sellerSKU][0]['purchaseDetailSku']) - matches.indexOf(obj[b.sellerSKU][0]['purchaseDetailSku']);
					})
					this.$set(this.sondata, 'orderItems', orderItems);
				}
				this.purchaseSkuData = obj2;
				this.createAutoPurchaseText();
			})
		},
		init(e) {
			this.UserInfo = JSON.parse(localStorage.getItem('role'))
			var str = JSON.parse(localStorage.getItem('role'))
			this.system = str.system
			this.dialogShow = true
			this.sondata = e
			this.purchaseSkuData = {};
			if (!e.orderCostEstimate.purchaseCostEstimate) {
				this.purchaseCostEstimate = 0
			} else {
				this.purchaseCostEstimate = e.orderCostEstimate.purchaseCostEstimate
			}
			if (!e.orderCostEstimate.logisticsCostEstimate) {
				this.logisticsCostEstimate = 0
			} else {
				this.logisticsCostEstimate = e.orderCostEstimate.logisticsCostEstimate
			}
			if (e.orderCostEstimate.logisticsEstimated==2 && e.orderCostEstimate.purchaseEstimated==2) {
				this.estimateBool = true
			} else {
				this.estimateBool = false
			}
			this.getPurchaseSkuData();
			this.autoDemandText = '';
			this.sellerType = this.sondata.seller.sellerType
			if (this.sondata.outInterceptStatus == 1) {
				this.interceptdisabled = true
			} else {
				this.interceptdisabled = false
			}
			if (this.sondata.address != null) {
				this.countryCode = this.sondata.address.countryCode
				this.stateOrRegion = this.sondata.address.stateOrRegion
				this.county = this.sondata.address.county
				this.name = this.sondata.address.name
				this.addressLine1 = this.sondata.address.addressLine1
				this.addressLine2 = this.sondata.address.addressLine2
				this.addressLine3 = this.sondata.address.addressLine3
				this.postalCode = this.sondata.address.postalCode
				this.city = this.sondata.address.city
				this.phone = this.sondata.address.phone
				this.id = this.sondata.address.id
			} else {
				this.countryCode = ''
				this.stateOrRegion = ''
				this.county = ''
				this.name = ''
				this.addressLine1 = ''
				this.addressLine2 = ''
				this.addressLine3 = ''
				this.postalCode = ''
				this.city = ''
				this.phone = ''
				this.id = ''
			}
			this.amazonOrderId = this.sondata.amazonOrderId
			this.demand = this.sondata.purchaseDemand || ''
			var purchaseDemands = this.sondata.purchaseDemands
			var prices = 0
			this.type = '一次采购'
			if (purchaseDemands.length > 0) {
				for (var i = 0; i < purchaseDemands.length; i++) {
					var purchaseItems = purchaseDemands[i].purchaseItems
					if (purchaseItems.length > 0) {
						this.type = '二次采购'
						for (var j = 0; j < purchaseItems.length; j++) {
							var price =
								purchaseItems[j].purchasePrice -
								purchaseItems[j].rebatePrice -
								purchaseItems[j].otherPrice
							prices += price
						}
					}
				}
			}
			this.purchasePrice = prices
			// this.blue_point = [];
			this.disabled = false

			// $(".buyer").attr({ style: "font-size:20px;" });
			this.isBlackDoc = false
			var str = JSON.parse(localStorage.getItem('role'))
			var blackInfo = {
				name: this.sondata.buyerName,
				country: this.sondata.countryMark,
				mail: this.sondata.buyerEmail,
				companyId: str.company_id,
			}
			ajaxPost(
				Baseurl + 'blackListController/selectBlackList',
				blackInfo
			).then((res) => {
				// console.log(res);
				this.buyerId = res.data.data.id
				var isExist = res.data.data.isExist
				if (isExist == '1') {
					// $(".buyer").attr({ style: "color:red;font-size:20px;" });
					this.disabled = true
					this.isBlackDoc = true
				}
			})
			this.Thelog()
			this.getInfo()
			this.orderTag()
			this.domesticTag()
			this.internationalTag()
			this.TheMemo()
			this.getListReamrkStandard()
		},
		Base_Print_form() {
			this.Print_form = {
				// 包
				paks: '',
				// 描述
				fullDescriptionOfGoods: '',
				// 数量
				qty: null,
				// 单价
				unitPrice: null,
				// 重量
				weight: null,
				// 出口人签名
				signatureOfShipperExporter: '',
				// 总金额
				totalAmount: null,
			}
		},
		Countermand() {
			this.PrintInvoiceVisible = false
			this.Base_Print_form()
		},
		// 关闭窗口
		Close_Print_File(done) {
			this.$confirm('您的操作不会被保存，确认关闭吗？')
				.then((_) => {
					done()
					this.Base_Print_form()
				})
				.catch((_) => {
					// this.Base_Print_form();
				})
		},
		Qty_Change(val) {
			this.Print_form.totalAmount = (
				val * this.Print_form.unitPrice
			).toFixed(2)
		},
		Print_Invoice() {
			this.PrintInvoiceVisible = true
			this.Print_form.unitPrice = this.infoData.orderItems[0].itemAmount
			// console.log(JSON.parse(JSON.stringify(this.infoData)));
		},
		Print_Determine() {
			//  console.log(JSON.parse(JSON.stringify(this.Print_form)));
			if (this.Print_form.paks == '') {
				this.$message.warning('请填写包')
				return
			} else if (this.Print_form.qty == null) {
				this.$message.warning('请填写数量')
				return
			} else if (this.Print_form.weight == null) {
				this.$message.warning('请填写重量')
				return
			} else if (this.Print_form.signatureOfShipperExporter == '') {
				this.$message.warning('请输入托运人/出口人签名')
				return
			} else if (this.Print_form.fullDescriptionOfGoods == '') {
				this.$message.warning('请填写完整描述')
				return
			}
			let internationalAirWaybillNo = null
			if (this.infoData.orderChannels.length !== 0) {
				let len = this.infoData.orderChannels.length - 1
				if (this.infoData.orderChannels[len].status != 1) {
					internationalAirWaybillNo = this.infoData.orderChannels[len]
						.conveyNumber
				} else {
					internationalAirWaybillNo = null
				}
			} else {
				internationalAirWaybillNo = null
			}

			let params = {
				purchaseDate: this.infoData.purchaseDate,
				orderItemId: this.infoData.orderItems[0].orderItemId,
				shipperCountry: 'CN',
				shipperProvince: 'GUANGDONG',
				shipperCity: 'SHENZHEN',
				shipperAddressOne: 'BAOANQU-FUYONGJIEDAO-XINHESHEQU',
				shipperAddressTwo: '',
				receiverCountry: this.infoData.address.countryCode1,
				receiverProvince: this.infoData.address.stateOrRegion,
				receiverCity: this.infoData.address.city,
				receiverAddressOne: this.infoData.address.addressLine1,
				receiverAddressTwo: this.infoData.address.addressLine2,
				receiverAddressThree: this.infoData.address.addressLine3,
				countryOfExport: 'CN',
				countryOfOriginOfGoods: 'CN',
				countryOfUltimateDestination: this.infoData.address
					.countryCode1,
				importer: '',
				internationalAirWaybillNo: internationalAirWaybillNo,
				mark: 'TOTAL',
				paks: this.Print_form.paks,
				fullDescriptionOfGoods: this.Print_form.fullDescriptionOfGoods,
				qty: this.Print_form.qty,
				weight: this.Print_form.weight,
				unitPrice: this.infoData.orderItems[0].itemAmount,
				totalAmount: this.Print_form.totalAmount,
				signatureOfShipperExporter: this.Print_form
					.signatureOfShipperExporter,
				issueTime: this.infoData.purchaseDate,
			}
			let id = this.infoData.orderId
			let url = 'PDFController/PDFMake'
			// let url = "commercialInvoiceController/export";
			// orderController/updateInternationalInvoicePrinftCount

			ajaxPost(Baseurl + url, params).then((res) => {
				// console.log(res);
				if (res.data.code == 200) {
					window.open(res.data.data)
					ajaxPost(
						Baseurl +
							'orderController/updateInternationalInvoicePrinftCount',
						{ id }
					).then((res) => {
						if (res.data.code == 200) {
							this.getInfo()
						}
					})
				}
			})
		},
		handleClick(tab, event) {
			if (tab.name == 2) {
				this.remarkType = 1
				this.TheMemo()
			} else if (tab.name == 3) {
				this.remarkType = 3
				this.TheMemo()
			}
		},
		handleSizeChange() {},
		handleCurrentChange() {},
		// 操作确定
		operationDetermination() {
			this.dialogShow = false
			this.$parent.Search() //父级的init
		},
		// 收货人信息编辑
		addEdit() {
			this.goodsdisplay = false //收货人信息
			this.goodshide = true //收货人信息
		},
		// 收货人信息保存
		addSetedit() {
			this.goodsdisplay = true //收货人信息
			this.goodshide = false //收货人信息
			// console.log(this.stateOrRegion);
			var addressarr = {
				countryCode: this.countryCode,
				stateOrRegion: this.stateOrRegion,
				county: this.county,
				name: this.name,
				addressLine1: this.addressLine1,
				addressLine2: this.addressLine2,
				addressLine3: this.addressLine3,
				postalCode: this.postalCode,
				city: this.city,
				phone: this.phone,
				id: this.id,
				amazonOrderId: this.amazonOrderId,
			}
			// console.log(addressarr);
			ajaxPost(
				Baseurl + 'addressController/updateAddress',
				addressarr
			).then((res) => {
				if (res.data.code == 200) {
					this.getInfo()
					// console.log(JSON.parse(JSON.stringify(res)));
					this.countryCode = res.data.data.countryCode
					this.stateOrRegion = res.data.data.stateOrRegion
                    this.county = res.data.data.county
					this.name = res.data.data.name
					this.addressLine1 = res.data.data.addressLine1
					this.addressLine2 = res.data.data.addressLine2
					this.addressLine3 = res.data.data.addressLine3
					this.postalCode = res.data.data.postalCode
					this.city = res.data.data.city
					this.phone = res.data.data.phone
					this.id = res.data.data.id
					this.sondata.address = addressarr
				}
			})
		},
		// 收货人信息取消
		addSetcancel() {
			this.goodsdisplay = true //收货人信息
			this.goodshide = false //收货人信息
		},
		//添加黑名单
		addBlack() {
			if (this.buyerId != null) {
				this.$alert('此买家已在黑名单列表！', '添加黑名单提示', {
					confirmButtonText: '确定',
					callback: (action) => {
						// this.$message({
						//     type: "info",
						//     message: `action: ${action}`
						// });
					},
				})
				return
			}
			this.$confirm('此操作将将此买家加入黑名单列表, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					var blackInfo = {
						id: this.buyerId,
					}
					var str = JSON.parse(localStorage.getItem('role'))
					var blackInfo = {
						name: this.sondata.buyerName,
						country: this.sondata.countryMark,
						mail: this.sondata.buyerEmail,
						companyId: str.company_id,
					}
					console.log(blackInfo)
					ajaxPost(
						Baseurl + 'blackListController/insertBlackList',
						blackInfo
					).then((res) => {
						console.log(res)
						var param = res.data
						if (param.code == 200) {
							this.buyerId = res.data.data.id
							var message = res.data.message
							if (message == '请求成功') {
								this.$message({
									type: 'success',
									message: '添加成功!',
								})
								// $(".buyer").attr({
								//     style: "color:red;font-size:20px;",
								// });
								this.disabled = true
								this.isBlackDoc = true
							}
						} else if (param.code == 500) {
							var message = param.data
							this.$alert('请求错误！', '', {
								confirmButtonText: '确定',
								callback: (action) => {
									// this.$message({
									//     type: "info",
									//     message: `action: ${action}`
									// });
								},
							})
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消',
					})
				})
		},
		//移除黑名单
		cancleBlack() {
			if (this.buyerId == null) {
				this.$alert('此买家未添加到黑名单列表！', '移除黑名单提示', {
					confirmButtonText: '确定',
					callback: (action) => {
						// this.$message({
						//     type: "info",
						//     message: `action: ${action}`
						// });
					},
				})
				return
			}
			this.$confirm('此操作将将此买家移除黑名单列表, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					var blackInfo = {
						id: this.buyerId,
					}
					ajaxPost(
						Baseurl + 'blackListController/deleteBlackList',
						blackInfo
					).then((res) => {
						console.log(res)
						var message = res.data.message
						if (message == '请求成功') {
							this.buyerId = null
							this.$message({
								type: 'success',
								message: '移除成功!',
							})
							// $(".buyer").attr({ style: "font-size:20px;" });
							this.disabled = false
							this.isBlackDoc = false
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消',
					})
				})
		},
		//检测黑名单
		checkBlack() {
			var str = JSON.parse(localStorage.getItem('role'))
			var blackInfo = {
				name: this.sondata.buyerName,
				country: this.sondata.countryMark,
				mail: this.sondata.buyerEmail,
				companyId: str.company_id,
			}
			ajaxPost(
				Baseurl + 'blackListController/checkBlackList',
				blackInfo
			).then((res) => {
				console.log(res)
				var data = res.data.data
				if (data == '2') {
					// $(".buyer").attr({ style: "color:red;font-size:20px;" });
					this.isBlackDoc = true
					this.$alert(
						'此买家已被别的公司加入黑名单！',
						'检测黑名单提示',
						{
							confirmButtonText: '确定',
							callback: (action) => {
								// this.$message({
								//     type: "info",
								//     message: `action: ${action}`
								// });
							},
						}
					)
				} else if (data == '1') {
					// $(".buyer").attr({ style: "color:red;font-size:20px;" });
					this.isBlackDoc = true
					this.$alert(
						'此买家【疑似】被别的公司加入黑名单！',
						'检测黑名单提示',
						{
							confirmButtonText: '确定',
							callback: (action) => {
								// this.$message({
								//     type: "info",
								//     message: `action: ${action}`
								// });
							},
						}
					)
				} else {
					this.$alert(
						'此买家未被任何公司加入黑名单！',
						'检测黑名单提示',
						{
							confirmButtonText: '确定',
							callback: (action) => {
								// this.$message({
								//     type: "info",
								//     message: `action: ${action}`
								// });
							},
						}
					)
				}
			})
		},
		//确认采购
		insertPurchase() {
			if (this.demand == '') {
				this.$alert('请先填写采购需求！', '采购提示', {
					confirmButtonText: '确定',
					callback: (action) => {
						// this.$message({
						//     type: "info",
						//     message: `action: ${action}`
						// });
					},
				})
				return
			}
			var str = JSON.parse(localStorage.getItem('role'))
			if (this.sondata.money != null) {
				this.amountReceived = this.sondata.money.amountChina
			} else {
				this.$alert('当前订单买家未下单，无法采购', '采购提示', {
					confirmButtonText: '确定',
					callback: (action) => {
						this.demand = ''
					},
				})
				return
			}
			var arr = this.sondata.orderItems
			// var productInfos = {
			//   title:"",
			//   sku:"",
			//   price:"",
			//   imageUrl:"",
			//   sourceLink:""
			// }
			var productInfos = new Array()
			for (var i in arr) {
				productInfos.push({
					title: arr[i]['title'] || '',
					sku: arr[i]['sellerSKU'] || '',
					imageUrl: arr[i]['imageUrl'] || '',
					sourceLink: arr[i]['saleLink'] || '',
					quantityOrdered: arr[i]['quantityOrdered'] || '',
					itemAmount: arr[i]['itemAmount'] || '',
					itemCurrencyCode: arr[i]['itemCurrencyCode'] || '',
				})
			}
			var param = {
				orderId: this.sondata.id,
				amazonOrderId: this.sondata.amazonOrderId,
				amountReceived: this.amountReceived,
				purchaseDate: this.sondata.purchaseDate,
				purchaseDemand: this.demand,
				shopName: this.sondata.countryMarks.countryName,
				shopId: this.sondata.countrySellerId,
				stuffId: str.rid,
				stock: this.sondata.quantityOfOrdered,
				type: this.type,
				companyId: str.company_id,
				productInfos: productInfos,
				rid: str.rid,
			}
			this.btnloading = true
			// console.log(param);
			ajaxPost(
				Baseurl + 'purchaseDemandController/insertPurchaseDemand',
				param
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.$alert('已生成采购需求！', '采购提示')
					this.demand = ''
					this.$emit('edit')
				} else {
					this.$alert(
						'上一次采购需求流程未完成无法添加新的采购需求',
						'采购提示'
					)
				}
				this.btnloading = false
			})
		},
		// 国际运单添加
		addWaybill() {
			this.$refs.internationaldis.init()
		},
		// 点击明细
		// Detailed() {
		//     this.$refs.Detaileddist.init();
		// },
		// hxMarket() {
		//     this.$refs.Markett.init(); //子级的init
		// },
		handleChange(value) {
			console.log(value)
		},
		// 保存
		Addedit() {
			this.tmenudisplay = true
			this.menudisplay = true
			this.menuhide = false
		},
		// 确认
		Adddel() {
			this.menudisplay = true
			this.delt = false
		},
		// 查看货源
		Viewsourcing(sku) {
			this.dialogFormVisible = true
			this.blue_point = []
			this.isRequestDone = false
			ajaxPost(Baseurl + 'productController/getProductSourceLink', {
				sku: sku,
				countryMark: this.sondata.countryMarks.countryMark,
			}).then((res) => {
				// console.log(res.data.data);
				// this.blue_point = res.data.data;
				const { code, data } = res.data
				if (code === 200) {
					this.blue_point = data
						.filter((item) => !!item)
						.map((item) => ({ value: item, type: false }))
					if (this.blue_point.length) {
						this.isRequestDone = true
					}
					// data.map(value => {
					//     this.blue_point.push({
					//         value: value,
					//         type: false,
					//     });
					// });
				}
				// console.log(this.blue_point);
			})
			this.sellerSKU = sku
		},
		showsourcing(sku) {
			this.sourcingurl = '加载中...'
			ajaxPost(Baseurl + 'productController/getProductSourceLink', {
				sku: sku,
				countryMark: this.sondata.countryMarks.countryMark,
			}).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					if (data.length) {
						this.sourcingurl = data.join(',')
					} else {
						this.sourcingurl = '暂无货源链接'
					}
				}
			})
		},
		hidesourcing() {
			this.sourcingurl = '暂无货源链接'
		},
		// 添加链接
		edit_blue_point(index, method) {
			if (this.blue_point.length < 10) {
				const param = {
					value: '',
					type: true,
				}
				this.blue_point.push(param)
			} else {
				this.$message('此链接记录货源链接最多10条字段')
			}
		},
		// 删除链接
		edit_blue_del(item, index) {
			this.$confirm('此操作将永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					this.blue_point.splice(index, 1)
					this.$message({
						type: 'success',
						message: '删除成功!',
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		// 新增
		Handle() {
			this.dialogTableVisible = true
		},
		handleRemove(file) {
			console.log(file)
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url
			this.dialogVisible = true
		},
		handleDownload(file) {
			console.log(file)
		},
		handleURL(url) {
			// alert(url);
			// console.log(url);
			window.open(url)
		},
		// 确定货源
		handleTure() {
			console.log(this.sellerSKU)
			console.log(this.blue_point)
			var arr = []
			this.blue_point.map((v) => {
				arr.push(v.value)
			})
			console.log(arr)
			if(this.sellerSKU){
				ajaxPost(Baseurl + 'productController/updateProductSourceLink', {
					sku: this.sellerSKU,
					sourceLinks: arr,
					areaName: this.sondata.countryMarks.countryMark,
				}).then((res) => {
					if (res) {
						this.$message({
							type: 'success',
							message: '设置成功!',
						})
						this.Viewsourcing(this.sellerSKU)
						this.dialogFormVisible = false
					}
				})
			}
			
		},
		Thelog() {
			ajaxPost(Baseurl + 'logisticsController/getOrderOperateLog', {
				orderId: this.sondata.id,
			}).then((res) => {
				if (res.data.code == 200) {
					this.activities = res.data.data
				}
			})
		},
		getInfo() {
			let API = Baseurl + 'logisticsController/getOrderDetailsByOrderId'
			let paramsData = {
				id: this.sondata.id,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					if(JSON.parse(data.financialEvents)){
						this.financialEvents = JSON.parse(data.financialEvents)[0]
					}
					this.infoChannel = data.orderChannels
					this.infoData = data
				}
			})
		},
		// 作废
		toVoid(item) {
			const UserInfo = JSON.parse(localStorage.getItem('role'))
			const handleRequest = () => {
				const API = Baseurl + 'logisticsController/updateOrderChannel'
				const paramsData = {
					id: item.id,
					status: '1',
					operateType: '1',
					roleId: UserInfo.rid,
				}
				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.$message.success('操作成功')
						this.getInfo()
					} else {
						this.$message.error(data)
					}
				})
			}
			this.$confirm('您确定要作废该国际运单吗？', '提示').then(() => {
				handleRequest()
			})
		},
		intercept() {
			var str = JSON.parse(localStorage.getItem('role'))
			this.$confirm('是否确认拦截，确认后无法取消', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				var obj = {
					id: this.sondata.id,
					roleId: str.rid,
				}
				ajaxPost(
					Baseurl + 'orderController/orderOutIntercept',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							type: 'success',
							message: '拦截成功!',
						})
						this.$emit('edit')
						this.interceptdisabled = true
					} else {
						this.$message.error(res.data.data)
					}
				})
			})
		},
		TheMemo() {
			var obj = {
				documentId: this.sondata.id,
				remarkType: this.remarkType,
			}
			ajaxPost(Baseurl + 'orderController/selectRemarkList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.momoList = res.data.data
					}
				}
			)
		},
		handleAvatarSuccess(file, fileList) {
			this.imageData.push(file)
		},
		handleRemove(file, fileList) {
			this.imageData = []
			for (var i = 0; i < fileList.length; i++) {
				this.imageData.push(fileList[i].response)
			}
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl1 = file.url
			this.dialogVisible1 = true
		},

		handleAvatarSuccess2(file, fileList) {
			this.imageData1.push(file)
			console.log(this.imageData1)
		},
		handleRemove2(file, fileList) {
			this.imageData1 = []
			for (var i = 0; i < fileList.length; i++) {
				this.imageData1.push(fileList[i].response)
			}
		},
		handlePictureCardPreview2(file) {
			this.dialogImageUrl2 = file.url
			this.dialogVisible2 = true
		},

		AddMomo() {
			if (this.remarkType === 1) {
				if (
					(this.GGtags.length == 0 && this.GNtags.length == 0) ||
					(this.GGtags == [] && this.GNtags == [])
				) {
					this.$message.error('请添加国际/国内运单标记！')
				} else if (this.textarea1 == '') {
					this.$message.error('请输入备忘录内容！')
				} else {
					this.MomoAjax()
				}
			} else if (this.remarkType === 3) {
				if (this.GGtags.length == 0 || this.GGtags == []) {
					this.$message.error('请添加国际运单标记！')
				} else if (this.textarea1 == '') {
					this.$message.error('请输入备忘录内容！')
				} else {
					this.MomoAjax()
				}
			}
		},
		MomoAjax() {
			var str = JSON.parse(localStorage.getItem('role'))
			for (var i = 0; i < this.imageData.length; i++) {
				this.images.push(this.imageData[i].data)
			}

			var obj = {
				insertType: 1,
				documentId: this.sondata.id,
				orderId: this.sondata.id,
				remarkContent: this.textarea1,
				roleId: str.rid,
				remarkImages: this.images,
				remarkType: this.remarkType,
				remarkId: '',
				remarkOrder: '',
				remarkStatus: '',
				id: '',
				purchaseMarkItems: this.GNtags,
				channelMarkItems: this.GGtags,
			}
			ajaxPost(Baseurl + 'orderController/insertRemark', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.$message({
							type: 'success',
							message: '添加备忘录成功!',
						})
						this.TheMemo()
						this.$emit('edit')
					} else {
						this.$message.error(res.data.data)
					}
					this.GNtags = []
					this.GGtags = []
					this.images = []
					this.imageData = []
					this.textarea1 = ''
				}
			)
			this.$refs.upload.clearFiles()
			this.Themomo = false
		},
		handleCommand1(val) {
			var obj = {
				orderInfos: [this.sondata],
				orderMarkId: val,
			}
			ajaxPost(Baseurl + 'orderController/updateOrderMark', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.$parent.init()
					} else {
						this.$message.error(res.data.data)
					}
				}
			)
		},
		//订单、订单号标签
		orderTag() {
			var obj = { itemCode: 'HYXUN0000010' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList1 = res.data.data
						this.sortByKey(this.colorList1, 'itemTypeIdInteger')
					}
				}
			)
		},
		//国内订单标签
		domesticTag() {
			var obj = { itemCode: 'HYXUN0000011' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList2 = res.data.data
						this.sortByKey(this.colorList2, 'itemTypeIdInteger')
					}
				}
			)
		},
		//国际订单标签
		internationalTag() {
			var obj = { itemCode: 'HYXUN0000012' }
			ajaxPost(Baseurl + 'purchaseController/selectItemList', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.colorList3 = res.data.data
						this.sortByKey(this.colorList3, 'itemTypeIdInteger')
					}
				}
			)
		},
		sortByKey(array, key) {
			return array.sort(function(a, b) {
				var x = a[key]
				var y = b[key]
				return x < y ? -1 : x > y ? 1 : 0
			})
		},
		AddChannel() {
			this.Themomo = true
		},
		handleAvatarSuccess1(res, file) {
			this.imageUrl = res.data
			// console.log(this.imageUrl)
		},
		Replace(val) {
			console.log(val)
			this.ImageId = val
			this.OrderImage = true
		},
		AddImage() {
			var obj = {
				id: this.ImageId.id,
				imageUrl: this.imageUrl,
				amazonOrderId: this.ImageId.amazonOrderId,
			}
			ajaxPost(
				Baseurl + 'orderController/updateOrderItemImageById',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.$message({
						message: '更换订单图片成功',
						type: 'success',
					})
					this.$emit('edit')
					this.sondata.orderItems = res.data.data
					console.log(res.data)
				} else {
					this.$message.error(res.data.data)
				}
				this.OrderImage = false
				this.imageUrl = ''
				this.$refs.uploadData.clearFiles()
			})
		},
		cancelUpdata() {
			this.imageUrl = ''
			this.$refs.uploadData.clearFiles()
			this.OrderImage = false
		},
		GGTagsChange(val) {
			this.GGtags.push(val)
			// console.log(this.GGtags)
		},
		GNTagsChange(val) {
			this.GNtags.push(val)
			// console.log(this.GNtags)
		},
		GGhandleClose(tag, index) {
			this.GGtags.splice(index, 1)
		},
		GNhandleClose(tag, index) {
			this.GNtags.splice(index, 1)
		},
		OpenToDealWith(val) {
			this.ToDealWith = true
			this.openWith = val
			this.openWithGNTags = JSON.parse(
				JSON.stringify(val.purchaseMarkItems)
			)
			this.openWithGGTags = JSON.parse(
				JSON.stringify(val.channelMarkItems)
			)
			console.log(val)
		},
		delGGTags(val, index) {
			console.log(val)
			this.openWithGGTags.splice(index, 1)
			this.deleteChannelMark.push(val.itemTypeId)
			console.log(this.openWithGGTags)
		},
		delGNTags(val, index) {
			console.log(val)
			this.openWithGNTags.splice(index, 1)
			this.deletePurchaseMark.push(val.itemTypeId)
			console.log(this.openWithGNTags)
		},
		SubEnd() {
			this.remarkStatusNo = 3
			if (this.textarea2 == '') {
				this.$message.error('请输入内容！')
			} else {
				this.EndAjax()
			}
		},
		SubNoEnd() {
			this.remarkStatusNo = 2
			if (this.textarea2 == '') {
				this.$message.error('请输入内容！')
			} else {
				this.EndAjax()
			}
		},
		EndAjax() {
			var str = JSON.parse(localStorage.getItem('role'))
			for (var i = 0; i < this.imageData1.length; i++) {
				this.images1.push(this.imageData1[i].data)
			}

			var obj = {
				insertType: 2,
				documentId: this.sondata.id,
				orderId: this.sondata.id,
				remarkContent: this.textarea2,
				roleId: str.rid,
				remarkImages: this.images1,
				remarkType: this.remarkType,
				remarkId: this.openWith.remarkId,
				remarkOrder: this.openWith.remarkOrder,
				remarkStatus: this.remarkStatusNo,
				id: this.openWith.id,
				purchaseMarkItems: this.openWithGNTags,
				channelMarkItems: this.openWithGGTags,
				deletePurchaseMark: this.deletePurchaseMark,
				deleteChannelMark: this.deleteChannelMark,
			}
			ajaxPost(Baseurl + 'orderController/insertRemark', obj).then(
				(res) => {
					if (res.data.code == 200) {
						if (this.remarkStatusNo == 3) {
							this.$message({
								type: 'success',
								message: '提交并完结成功!',
							})
						} else if (this.remarkStatusNo == 2) {
							this.$message({
								type: 'success',
								message: '提交未完结成功!',
							})
						}
						this.TheMemo()
						this.$emit('edit')
					} else {
						this.$message.error(res.data.data)
					}
					this.deleteChannelMark = []
					this.deletePurchaseMark = []
					this.images1 = []
					this.imageData1 = []
					this.textarea2 = ''
				}
			)
			this.$refs.upload.clearFiles()
			this.ToDealWith = false
		},
		openIncreaseWaybill() {
			this.$refs.IncreaseWaybill.openComponents(this.infoData)
		},
		startHYLogistics() {
			const API = Baseurl + 'orderController/useHxLogisticsChannel'
			const paramsData = { id: this.sondata.id }
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.sondata.applyFromStatus = 1
					this.$message.success('操作成功')
					this.$emit('edit')
				} else {
					this.$message.error(data || '操作失败')
				}
			})
		},
		IncreaseWaybillRefreshData() {
			this.getInfo()
		},
		getListReamrkStandard() {
			const API =
				Baseurl +
				'purchaseRemarksStandardController/selectPurchaseRemarksStandardList'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listRemarkStandard = data
				}
			})
		},
		HXShops() {
			this.Hymall = true
			this.HXShopsSearch()
		},
		HXShopsSearch() {
			var obj = {
				page: 1,
				size: 1000,
				searchString: this.ShopsString,
			}
			ajaxPost(
				Baseurl + 'inventoryController/selectOnLineInventorysList',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.GoodsMall = res.data.data.list
				}
			})
		},
		HXShopsReset() {
			this.ShopsString = ''
			this.HXShopsSearch()
		},
	},
}
</script>
<style lang="scss" scoped>
.bor1 {
	::v-deep {
		.el-input__inner {
			border: 1px solid red;
		}
	}
}
.PrintInvoice {
	padding-top: 20px;
	text-align: right;
}
.el-tabs__header {
	margin: 0;
}
.dright {
	float: right;
	overflow: hidden;
}
.avatar-uploader {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	width: 200px;
	height: 200px;
}
.avatar-uploader:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 200px;
	height: 200px;
	line-height: 200px;
	text-align: center;
}
.avatar {
	width: 200px;
	height: 200px;
	display: block;
}

.FBMOrder {
	width: 98%;
	position: relative;
	.el-textarea__inner:focus {
		outline: 0;
		border-color: #fff;
	}
	.el-textarea__inner {
		border: 1px solid #fff;
	}
	.el-input-group__prepend {
		padding: 0 2px;
		text-align: center;
	}
	.el-form-item__label {
		text-align: center;
	}
	.el-dialog__wrapper {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: auto;
		background: rgba(0, 0, 0, 0.2);
		margin: 0;
		.el-dialog {
			position: relative;
			margin: 0 auto 50px;
			background: #fff;
			border-radius: 2px;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
			box-sizing: border-box;
			margin-top: 15vh;
			h3 {
				line-height: 45px;
			}
			.titleInfo {
				margin-bottom: 10px;
			}
			.sright {
				float: right;
				font-size: 20px;
				line-height: 44px;
				color: #409eff;
			}
			.speed-of-progress {
				width: 100%;
				border: 1px solid #dcdfe6;
				border-radius: 5px;
				padding: 20px 0;
			}
			.goods-box {
				width: 100%;
				padding-bottom: 10px;
				border-bottom: 1px solid #dcdfe6;
			}
			.el-col-21 a {
				width: 100%;
				overflow: hidden;
				white-space: nowrap;
			}
			.label-l {
				margin-left: 20px;
			}
			.line-height {
				line-height: 30px;
				overflow: hidden;
				white-space: nowrap;
			}
			.address {
				margin-top: 10px;
				border-bottom: 1px solid #dcdfe6;
				padding-bottom: 10px;
			}
			.order-t {
				line-height: 28px;
			}
			.waybill-title {
				margin-top: 10px;
			}
			.el-input-left {
				margin-left: 5px;
			}
			.order-amount {
				font-size: 13px;
				padding: 10px 20px;
				border-bottom: 1px solid #dcdfe6;
			}
			.waybill {
				border-bottom: 1px solid #dcdfe6;
				padding-bottom: 20px;
			}
			.waybill-item-bottom-right {
				float: right;
			}
			.el-textarea {
				width: 80%;
			}
			.el-dialog__foote {
				text-align: right;
			}
			.el-dialog__body {
				padding: 30px 20px;
				max-height: 700px !important;
				color: #606266;
				font-size: 14px;
			}
			.inner-goods {
				overflow: hidden;
				padding: 5px 0;
				border-bottom: 1px solid #eee;
				.inner-goods-img {
					width: 80px;
					height: 80px;
					float: left;
					margin-right: 10px;
				}
				.inner-goods-text {
					width: 60%;
					float: left;
					line-height: 30px;
					white-space: nowrap;
					overflow: hidden;
				}
			}
			.el-input-group__prepend {
				width: 52px;
			}
			.imgsel {
				.el-icon-circle-close {
					color: #409eff;
				}
			}
			.commodityt {
				overflow: hidden;
				width: 100%;
				padding: 10px 0;
				p {
					font-size: 16px;
					display: block;
					float: left;
				}
				.el-input__inner {
					height: 40px;
				}
			}
		}
		label {
			font-weight: 600;
			margin-right: 5px;
		}
	}
	.el-table {
		overflow: initial;
	}
	.el-table__body-wrapper {
		overflow: initial;
	}
	a {
		color: #409eff;
	}
	#price {
		display: flex;
	}
	.el-col-3 {
		width: 13%;
	}
	#address {
		height: 200px;
	}
	.demand {
		width: 100%;
		// height: 100px;
		margin-top: 10px;
		padding: 10px;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
	}
	.demand_inp {
		width: 100%;
		display: flex;
		justify-content: left;
	}
	.demand_num {
		width: 100%;
		height: 30px;
		display: flex;
		justify-content: space-between;
		line-height: 30px;
	}
	.channel-flex {
		display: flex;
		margin-right: 20px;
	}
	.borbuttom {
		width: 100%;
		border-bottom: 1px solid #e4e7ed;
	}
	.borbuttom p {
		line-height: 50px;
	}
	.el-tag--dark {
		border: 0;
	}
}
.textlang {
	width: 100px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}

.picsImg {
	width: 50px;
	height: 30px;
}
.purchase-input-box{
	display: flex;
	margin-top: 5px;
	.purchase-title{
		display: flex;
		margin-right: 15px;
		height: 30px;
		align-items: center;
	}
	.purchase-content{
		.purchase-row{
			display: flex;
			align-items: center;
			margin-bottom: 5px;
			.item{
				display: flex;
				align-items: center;
				margin-right: 10px;

				.label{
					white-space: nowrap;
				}
			}
		}
	}
}
.dialog-title1{
	display: flex;
	align-items: center;
	.title1{
		font-size: 18px;
	}
	.el-button{
		margin-left: 500px;
	}
}
.el-input__suffix-inner{
	.el-button{
		padding-left: 0;
		padding-right: 0;
	}
}
/deep/ .purchase-url-input input{
	padding-right: 170px !important;
}
.btns-row{
	display: flex;
	justify-content: flex-end;
}
.title-row{
	display: flex;
	align-items: center;
}

</style>
